[
  [
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 4987,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 1732,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 559,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 509,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 259,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 107,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 104,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 93,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 55,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 51,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 6,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 5027,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 1913,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 585,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 512,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 265,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 109,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 105,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 93
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 61,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 15
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 3,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 1
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 5027
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 2275,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 606,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 512
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 275,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 120,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 110,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 94,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 85,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 57
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 15
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 9,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 1
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 5027
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 2317,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 616,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 513,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 339,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 124,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 113,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 104,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 96,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 15
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 10,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 1
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 5027
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 2405,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 715,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 651,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 384,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 127,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 115,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 98,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 63,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 15
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 5082,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 2474,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 919,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 723,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 460,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 129,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 124,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 99,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 15
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 12
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 1
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 5729,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 2814,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 922,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 757,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 533,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 163,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 142,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 138,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 101,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 87,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 12
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Savannah State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 7127,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 3015,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 942,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 808,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 620,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 242,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 165,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 149,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 146,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 107,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 49,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 30,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 4,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 2
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 9113,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 3702,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 1235,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 878,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 697,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 288,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 246,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 199,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 198,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 117,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 92,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 82,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 44,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 31,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 19,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T09:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T09:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 3,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T09:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T09:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 11053,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 4330,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 1456,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 919,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 748,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 486,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 370,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 260,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 246,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 238,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 145,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 97,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 64,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 37,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 7,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1,
      "timestamp": "2023-02-27T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 13565,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 4868,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 1558,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 1087,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1075,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 686,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 557,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 470,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 395,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 297,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 196,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 177,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 173,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 123,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 71,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 44,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 28,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 11,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 8,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3,
      "timestamp": "2023-02-27T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 15730,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 5374,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 1802,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 1244,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1244,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 1029,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 695,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 623,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 562,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 387,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 348,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 280,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 278,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 211,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 138,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 77,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 32,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 12,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6,
      "timestamp": "2023-02-27T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 17263,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 5998,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 1978,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 1432,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 1363,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1358,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 858,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 742,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 631,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 454,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 431,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 400,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 357,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 355,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 215,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 87,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 72,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 68,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 47,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 18,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T13:00:00-05:00",
      "votes": 12
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T13:00:00-05:00",
      "votes": 11
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T13:00:00-05:00",
      "votes": 7
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 18913,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 6983,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 2081,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 1768,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 1693,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1474,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 1184,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 849,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 707,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 522,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 477,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 438,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 415,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 413,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 258,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 119,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 104,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 76,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 49,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 26,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 14,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9,
      "timestamp": "2023-02-27T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 20178,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 8025,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 2306,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 2005,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 1955,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1542,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 1431,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 967,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 778,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 599,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 570,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 511,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 458,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 422,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 305,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 148,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 109,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 81,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 50,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T15:00:00-05:00",
      "votes": 26
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T15:00:00-05:00",
      "votes": 14
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T15:00:00-05:00",
      "votes": 9
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 20693,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 8658,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 2426,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 2298,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 2059,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 1826,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 1703,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1074,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 808,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 790,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 662,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 548,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 508,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 458,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 332,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 239,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 116,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 114,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 93,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 86,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 47,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T16:00:00-05:00",
      "votes": 9
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 21303,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 9662,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 2589,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 2514,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 2215,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 2082,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 1857,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1109,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 927,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 868,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 725,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 628,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 527,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 463,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 344,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 300,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 117,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 116,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 100,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 97,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 48,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 26,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 11,
      "timestamp": "2023-02-27T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 22379,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 10316,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 2853,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 2782,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 2382,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 2304,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 1998,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1182,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 985,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 924,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 917,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 761,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 621,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 556,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 390,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 337,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 125,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 122,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 110,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 106,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 50,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 29,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 12,
      "timestamp": "2023-02-27T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 23591,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 10805,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 3110,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3013,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 2574,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 2545,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2054,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1247,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1214,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1011,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1010,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 818,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 674,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 623,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 391,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 359,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 136,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 128,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 118,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 112,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 78,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 52,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 30,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T19:00:00-05:00",
      "votes": 12
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 24723,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 12046,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 3307,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3234,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3021,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 2864,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2123,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1371,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1314,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1136,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1080,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 851,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 684,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 650,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 393,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 388,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 198,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 156,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 149,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 133,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 129,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 56,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 34,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T20:00:00-05:00",
      "votes": 12
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 26858,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 12409,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 3611,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3413,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3327,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3064,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2319,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1482,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1391,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1310,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1145,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 950,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 700,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 691,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 451,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 401,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 245,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 234,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 158,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 154,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T21:00:00-05:00",
      "votes": 56
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 36,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 13,
      "timestamp": "2023-02-27T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 27194,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 13167,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 3924,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3705,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3582,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3218,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2358,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1619,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1459,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1344,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1224,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 997,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 756,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 714,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 476,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 404,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 321,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 318,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 233,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 227,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 161,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 60,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T22:00:00-05:00",
      "votes": 56
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 14,
      "timestamp": "2023-02-27T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 28431,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 13465,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4127,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3780,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3629,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3315,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2476,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1724,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1474,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1388,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1238,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1066,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 853,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 719,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 498,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 421,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 407,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 356,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 241,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 234,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T23:00:00-05:00",
      "votes": 161
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 61,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 57,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 15,
      "timestamp": "2023-02-27T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 29437,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 13757,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4277,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3832,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3658,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3455,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2616,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1829,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1476,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1391,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1282,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1094,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 874,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 724,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 512,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 428,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 408,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 363,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 250,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 241,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 162,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T00:00:00-05:00",
      "votes": 61
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T00:00:00-05:00",
      "votes": 57
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 17,
      "timestamp": "2023-02-28T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 29455,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 13952,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4323,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3882,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3747,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3469,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2636,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1859,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1477,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1400,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1307,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1105,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 941,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 725,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 517,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T01:00:00-05:00",
      "votes": 428
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 410,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 364,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 253,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 243,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T01:00:00-05:00",
      "votes": 162
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 62,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 58,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 19,
      "timestamp": "2023-02-28T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 29570,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 13992,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4342,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3927,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3891,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3476,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2704,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1866,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1499,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1402,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1397,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1110,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 942,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 726,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 520,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 436,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 429,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 410
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 256,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 243
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 162
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 62
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 58
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 20,
      "timestamp": "2023-02-28T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 29570
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 14279,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4344,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 3944,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3892,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3479,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2714,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1868,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1520,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1418,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1404,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1111,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 943,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 727,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 523,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 439,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 429
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 410
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 258,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 243
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 163,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 62
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 58
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 20
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 29570
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 14403,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4428,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 4017,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3903,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3504,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 2714
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1874,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 1520
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1452,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 1404
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1129,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 945,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 728,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 523
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 441,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 429
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 410
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 258
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 245,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 163
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 63,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 58
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 20
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 29570
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 14436,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4452,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 4063,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 3915,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3569,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2715,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1885,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1602,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1522,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1414,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1131,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 948,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 729,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 528,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 444,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 430,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 410
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 261,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 248,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 235,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 63
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 58
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 20
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 29572,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 14870,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4492,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 4265,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4053,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3635,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2752,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 1960,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1678,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1574,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1462,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1144,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 952,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T06:00:00-05:00",
      "votes": 729
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 532,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 452,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T06:00:00-05:00",
      "votes": 430
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 413,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 288,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 266,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 249,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 66,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 61,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T06:00:00-05:00",
      "votes": 20
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 29743,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 15132,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4565,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 4378,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4168,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3698,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2796,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2058,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1732,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1718,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1534,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1262,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 963,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 731,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 540,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 463,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 444,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 414,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 290,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 276,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 255,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 71,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 64,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T07:00:00-05:00",
      "votes": 20
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 30617,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 15363,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4735,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 4536,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4308,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3832,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 2876,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2121,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1844,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1794,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1594,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1311,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1035,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 737,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 589,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 556,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 475,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 422,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 307,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 294,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 268,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 80,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T08:00:00-05:00",
      "votes": 64
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 21,
      "timestamp": "2023-02-28T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 30907,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 16202,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 5038,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 4882,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4502,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 3985,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3016,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2170,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 1990,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1871,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1638,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1386,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1084,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 746,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 674,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 568,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 476,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 457,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 334,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 296,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 289,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 82,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 66,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 22,
      "timestamp": "2023-02-28T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 32999,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 16576,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 5539,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 5332,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4620,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 4230,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3298,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2282,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 2107,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 1994,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1709,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1437,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1384,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 758,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 701,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 596,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 498,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 484,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 480,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 465,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 298,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 86,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 69,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 26,
      "timestamp": "2023-02-28T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 33430,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 17364,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 5805,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 5711,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 4840,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 4455,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3646,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2446,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 2226,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2074,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1812,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1542,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1497,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 775,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 719,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 658,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 615,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 558,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 481,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 470,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 306,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 93,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 75,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 31,
      "timestamp": "2023-02-28T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 34209,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 18003,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 6293,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 5925,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5017,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 4665,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3788,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2489,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 2354,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2184,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 1981,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1732,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1546,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 785,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 742,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 734,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 726,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 619,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 494,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 485,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 307,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 100,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 77,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 36,
      "timestamp": "2023-02-28T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 35527,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 19163,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 6796,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6013,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5138,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 4906,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3890,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2594,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 2430,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2387,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2174,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1808,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1680,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1078,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 845,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 794,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 749,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 726,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 523,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 492,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 352,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 104,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 79,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 38,
      "timestamp": "2023-02-28T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 36450,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 19867,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 7308,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6120,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 5434,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5252,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 3976,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 2850,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 2802,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2485,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2290,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1930,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1738,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1138,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 980,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 856,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 757,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 741,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 531,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 505,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 363,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 109,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 82,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 39,
      "timestamp": "2023-02-28T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 37546,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 20742,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 7695,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6340,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 5768,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5461,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4050,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3083,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3075,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2518,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2368,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 1962,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1765,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1178,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1103,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 912,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 791,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 768,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 534,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 515,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 434,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 115,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 83,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T15:00:00-05:00",
      "votes": 39
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 38755,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 21534,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 8089,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6429,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 6020,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5605,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4159,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3330,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3244,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2566,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2404,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2042,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1809,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1250,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1238,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 996,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 835,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 789,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 549,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 539,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 441,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 125,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T16:00:00-05:00",
      "votes": 83
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T16:00:00-05:00",
      "votes": 39
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 40278,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 22242,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 8360,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6507,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 6176,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5837,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4251,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3495,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3292,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2687,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2510,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2102,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 1927,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1345,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1303,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1039,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 842,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 803,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 569,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 546,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 458,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 138,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 84,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T17:00:00-05:00",
      "votes": 39
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 41659,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 23212,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 8623,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 6626,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 6353,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 5961,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4307,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3608,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3298,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2757,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2570,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2132,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2009,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1427,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1411,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1130,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 864,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 806,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 575,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T18:00:00-05:00",
      "votes": 546
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 529,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 144,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 89,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 40,
      "timestamp": "2023-02-28T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 42140,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 23716,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 8999,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 7050,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 6657,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6091,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4328,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3703,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3413,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2842,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2653,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2145,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2079,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1600,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1499,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1188,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 924,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 909,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 600,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 576,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 553,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 149,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T19:00:00-05:00",
      "votes": 89
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T19:00:00-05:00",
      "votes": 40
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 43544,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 24378,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 9248,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 7425,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7037,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6335,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4443,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3809,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3594,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 2916,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2762,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2219,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2169,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1661,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 1637,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1223,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1127,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 939,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 603,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 579,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 559,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 154,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T20:00:00-05:00",
      "votes": 89
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 44,
      "timestamp": "2023-02-28T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 46454,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 25013,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 9520,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 7747,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7177,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6455,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4528,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 3905,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3894,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3051,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 2882,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2284,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2266,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2151,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1833,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1308,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1257,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 943,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 608,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 582,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 561,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 158,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 90,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T21:00:00-05:00",
      "votes": 44
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 47643,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 25907,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 9781,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 7949,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7399,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6490,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4637,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4130,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 3989,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3121,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3014,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2344,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2340,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2304,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 1962,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1369,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1316,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 944,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 609,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 585,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 562,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 161,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 91,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 45,
      "timestamp": "2023-02-28T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 48671,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 27161,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10145,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 8347,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7502,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6552,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4672,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4243,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4053,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3247,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3169,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2374,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2370,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2349,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2177,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1377,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1356,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1030,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 611,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 592,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 563,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 163,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 92,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 49,
      "timestamp": "2023-02-28T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 49826,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 27454,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10241,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 8776,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7617,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6608,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4731,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4283,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4219,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3344,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3288,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2496,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2383,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2377,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2274,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1400,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1384,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1065,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 614,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 596,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T00:00:00-05:00",
      "votes": 563
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T00:00:00-05:00",
      "votes": 163
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T00:00:00-05:00",
      "votes": 92
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 52,
      "timestamp": "2023-03-01T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50039,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 27729,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10345,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 9394,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7698,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6614,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4743,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4454,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4285,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3363,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3346,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2522,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2507,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2394,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2382,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1411,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1386,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1066,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T01:00:00-05:00",
      "votes": 614
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 599,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 564,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 166,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T01:00:00-05:00",
      "votes": 92
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T01:00:00-05:00",
      "votes": 52
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50040,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 27902,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10484,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 9414,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7707,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6616,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4757,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4522,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4292,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3438,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3410,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2587,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2510,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2395,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2387,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1418,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1387,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1067,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T02:00:00-05:00",
      "votes": 614
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T02:00:00-05:00",
      "votes": 599
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T02:00:00-05:00",
      "votes": 564
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 167,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 95,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 53,
      "timestamp": "2023-03-01T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50041,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 28135,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10546,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 9424,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7802,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6619,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4761,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4541,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4301,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3478,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3464,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2594,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2513,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 2395
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2388,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1426,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1388,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1068,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 615,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 599
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 564
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 167
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 96,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 53
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50042,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 28386,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10587,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 9462,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7868,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6627,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 4761
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4593,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4322,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3510,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3484,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2597,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2521,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 2395
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 2388
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1428,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1390,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 1068
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 615
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 599
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 566,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 169,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 96
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 54,
      "timestamp": "2023-03-01T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50089,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 28470,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10617,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 10044,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7920,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6646,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4766,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4694,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4325,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3558,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3554,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2610,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2527,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2398,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2390,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1432,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1392,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1071,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 651,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 608,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 567,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 172,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 96
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 54
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50090,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 28637,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 10684,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 10672,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 7968,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6779,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4783,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4769,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4384,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3624,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3621,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2628,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2555,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2416,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2397,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1461,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1440,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1073,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 690,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T06:00:00-05:00",
      "votes": 608
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 568,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 176,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T06:00:00-05:00",
      "votes": 96
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T06:00:00-05:00",
      "votes": 54
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 50217,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 28881,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 11015,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 10946,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8058,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6836,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 4895,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4779,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4500,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 3829,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3768,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2688,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2570,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2455,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2417,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1530,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1459,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T07:00:00-05:00",
      "votes": 1073
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 694,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 610,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 570,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 182,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 97,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 55,
      "timestamp": "2023-03-01T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 51183,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 29168,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 11372,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 11327,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8202,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6920,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5064,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4795,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4645,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4022,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3820,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2753,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2616,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2532,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2485,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1605,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1474,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1076,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 699,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 617,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 574,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 204,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 98,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 57,
      "timestamp": "2023-03-01T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 52275,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 30087,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 12314,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 11871,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8362,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 6985,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5158,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4833,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4833,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4205,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 3998,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 2881,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 2851,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2597,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2504,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1617,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1530,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1081,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 702,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 618,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 578,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 211,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T09:00:00-05:00",
      "votes": 98
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 60,
      "timestamp": "2023-03-01T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 53376,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 30631,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 12795,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 12398,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8516,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 7388,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5306,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 4948,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4871,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4355,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4128,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 3249,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3044,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2646,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2524,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1716,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1556,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1089,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 706,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 623,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 581,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 213,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 101,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 61,
      "timestamp": "2023-03-01T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 54548,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 31369,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 13188,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 12872,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8648,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 7863,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5428,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 5048,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 4992,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4627,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4162,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 3560,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3110,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2673,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2532,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1787,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1574,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1109,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 707,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 624,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 582,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 215,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T11:00:00-05:00",
      "votes": 101
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 66,
      "timestamp": "2023-03-01T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 55964,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 32057,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 13635,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 13323,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 8989,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 8031,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5649,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 5464,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 5191,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4826,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4240,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 3877,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3182,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2723,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2699,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1814,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1611,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1121,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 752,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 629,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 585,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 218,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 125,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 117,
      "timestamp": "2023-03-01T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 57463,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 32322,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 14023,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 13592,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 9230,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 8193,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 5798,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5792,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 5315,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 4992,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4305,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 4038,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3257,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 2919,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2734,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 1832,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1629,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1126,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 759,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 633,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 587,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 232,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 131,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T13:00:00-05:00",
      "votes": 117
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 58331,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 32922,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 14414,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 14146,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 9938,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 8431,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 6112,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 5986,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5824,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 5597,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4465,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 4186,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3565,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 3077,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2784,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2027,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1642,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1198,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 770,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 650,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T14:00:00-05:00",
      "votes": 587
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 250,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 138,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 119,
      "timestamp": "2023-03-01T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 59370,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 33314,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 15271,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 14585,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 10637,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 8612,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 6640,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 6523,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 5962,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 5917,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4578,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 4561,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3623,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 3447,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2817,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2139,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1723,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1308,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 774,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 664,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 611,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 253,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 143,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 121,
      "timestamp": "2023-03-01T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 60476,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 34051,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 16159,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 15003,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 11139,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 8900,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 7490,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 6824,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 6309,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 6191,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 4823,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4736,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3819,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 3581,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2870,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2249,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1790,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1416,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 879,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 718,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 680,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 261,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 144,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 123,
      "timestamp": "2023-03-01T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 61570,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 34607,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 16603,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 15521,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 11673,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 9168,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 8132,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 6934,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 6397,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 6314,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5037,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 4839,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4091,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 3914,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2879,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2255,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1843,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1449,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 909,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 852,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 770,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 266,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 145,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 130,
      "timestamp": "2023-03-01T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 63187,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 34850,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 17060,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 16359,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 12115,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 9380,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 8349,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 7106,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 6527,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 6431,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5255,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5063,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 4273,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4252,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 2979,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2377,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1905,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1498,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 973,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 923,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 785,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 270,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 200,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 133,
      "timestamp": "2023-03-01T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 63833,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 35293,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 17354,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 17142,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 12548,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 11209,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 9589,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 8766,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 7443,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 6663,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 6589,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5386,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5217,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4366,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3064,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2428,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 1972,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1595,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1001,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 976,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 803,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 290,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 214,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 168,
      "timestamp": "2023-03-01T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 65610,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 35856,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 18028,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 17893,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17072,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 13115,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 9854,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 9616,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 7574,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 7047,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 6961,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5526,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5326,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4645,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3083,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2476,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 2422,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1668,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1010,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1008,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 830,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 374,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 218,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-01T20:00:00-05:00",
      "votes": 168
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 66822,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 36872,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 18936,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 18354,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17367,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 13816,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 10650,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 10278,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 7624,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 7521,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7340,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5692,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5419,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4783,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3105,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 2862,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2638,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1849,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1020,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1013,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 964,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 385,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 226,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 214,
      "timestamp": "2023-03-01T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 68001,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 37853,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 19645,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 18648,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17517,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 14592,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 11393,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 10714,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 7957,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 7913,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7495,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5760,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5508,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4853,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3158,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3075,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2652,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1900,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1085,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1062,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1030,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 405,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 266,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 229,
      "timestamp": "2023-03-01T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 70121,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 38324,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 20530,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 19215,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17725,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 14947,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 11898,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11174,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8189,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8157,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7546,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 5932,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5636,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4857,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3206,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3103,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2656,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1931,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1183,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1067,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T23:00:00-05:00",
      "votes": 1030
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 411,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 268,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 236,
      "timestamp": "2023-03-01T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 71187,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 38561,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 20784,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 20287,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17853,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15187,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 12113,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11277,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8412,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8230,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7625,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6068,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5657,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4872,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3226,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3142,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T00:00:00-05:00",
      "votes": 2656
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1932,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1207,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T00:00:00-05:00",
      "votes": 1067
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1035,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 412,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T00:00:00-05:00",
      "votes": 268
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 238,
      "timestamp": "2023-03-02T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72059,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 38607,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 21212,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 20816,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17872,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15470,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 12263,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11354,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8416,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8232,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7627,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6136,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5678,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 4906,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3229,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3162,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2657,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1935,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1211,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1090,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T01:00:00-05:00",
      "votes": 1035
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 414,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T01:00:00-05:00",
      "votes": 268
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T01:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72060,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 39103,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 21551,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 20845,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17878,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15565,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 12606,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11358,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8418,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8236,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7657,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6154,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5770,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5088,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3295,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3170,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2658,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1940,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1222,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1102,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 1035
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 414
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 268
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 239,
      "timestamp": "2023-03-02T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72067,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 39582,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 21770,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 20852,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17880,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15574,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 12812,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11426,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8421,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8239,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7686,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6162,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 5969,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5222,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3346,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 3170
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2661,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 1940
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1300,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 1102
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1048,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 414
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 268
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72179,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 39603,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 22012,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 20857,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 17880
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15724,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 13063,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11540,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8425,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8412,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 7821,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6175,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6146,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5223,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 3346
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3180,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2677,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1943,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1371,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 1102
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 1048
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 416,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 281,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72181,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 39676,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 22158,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 21064,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17902,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 15915,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 13309,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11626,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8520,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8435,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 8108,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6243,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6192,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 5223
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3348,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3191,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2707,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1944,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1379,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1172,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 1048
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 419,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 281
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72386,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 39732,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 22348,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 21799,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17933,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 16344,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 13439,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 11862,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 8617,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8570,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8439,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6275,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6272,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5239,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3358,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3196,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2709,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 1976,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1387,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1212,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1050,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 421,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 284,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T06:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 72507,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 40027,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 22887,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 22693,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 17966,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 16838,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 13709,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 12024,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 8854,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 8747,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8554,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6376,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6372,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5394,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3378,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3375,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2826,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2030,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1403,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1219,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1069,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 424,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 285,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 240,
      "timestamp": "2023-03-02T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 74133,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 40741,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 23318,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 23280,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18116,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 17994,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 13982,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 12199,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 9194,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 9061,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 8657,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6490,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6473,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5590,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3454,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3428,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2851,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2088,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1414,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1221,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1079,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 436,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 287,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 241,
      "timestamp": "2023-03-02T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 75303,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 41042,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 24154,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 24035,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 18888,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18195,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 14337,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 12880,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 9513,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 9382,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 9100,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6659,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6630,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5707,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3632,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3573,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2893,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2167,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1476,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1225,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1141,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 453,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 290,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 246,
      "timestamp": "2023-03-02T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 75691,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 41596,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 24957,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 24755,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 19701,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18270,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 14952,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 13710,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 9857,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 9732,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 9730,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 6892,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6826,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 5937,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3789,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3644,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 2998,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2378,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1515,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1233,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1174,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 459,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T10:00:00-05:00",
      "votes": 290
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 258,
      "timestamp": "2023-03-02T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 76159,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 42166,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 25597,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 25504,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 20346,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18434,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 15414,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 14255,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 10301,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 10194,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 10099,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7204,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 6980,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 6094,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3853,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3688,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3016,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2563,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1557,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1247,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1184,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 494,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 294,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 273,
      "timestamp": "2023-03-02T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 77095,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 42889,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 26392,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 26247,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 21609,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18858,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 15899,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 14760,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 10722,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 10507,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 10276,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7394,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7187,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 6382,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3910,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3787,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3026,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 2953,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1570,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1266,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1205,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 505,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 302,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 276,
      "timestamp": "2023-03-02T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 78147,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 43207,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 27088,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 27069,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 22419,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 18994,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 16340,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 15601,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 11142,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 10628,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 10569,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7516,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7247,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 6640,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 3970,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3821,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3180,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 3148,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1584,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1294,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1259,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 509,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 304,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 277,
      "timestamp": "2023-03-02T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 78693,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 43594,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 27850,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 27523,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 22880,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 19434,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 16831,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 16060,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 11441,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 11081,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 10705,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7633,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7267,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 6773,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4135,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3864,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 3348,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3277,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1624,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1356,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1266,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 538,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 305,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 282,
      "timestamp": "2023-03-02T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 79901,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 44112,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 28320,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 28098,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 23286,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 19498,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 17549,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 16575,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 11773,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 11247,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11164,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7721,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7339,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 6968,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4287,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3878,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 3420,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3293,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1675,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1412,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1350,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 554,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 306,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 292,
      "timestamp": "2023-03-02T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 80901,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 44920,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 29395,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 28784,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 23842,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 19633,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 18485,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 17288,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 12175,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11575,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 11553,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 7894,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7434,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 7240,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4313,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3916,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 3577,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3315,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1778,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1446,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1367,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 566,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 330,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 307,
      "timestamp": "2023-03-02T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 81334,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 45441,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 29886,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 29599,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 24093,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 19831,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 19171,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 18156,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 12608,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 11814,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11692,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8007,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7604,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 7538,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4376,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 3996,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 3759,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3458,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1837,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1466,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1414,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 570,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 338,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 312,
      "timestamp": "2023-03-02T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 82853,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 46021,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 30966,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 30293,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 24650,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 20096,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 19709,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 19194,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 12932,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 11993,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11728,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8181,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 7916,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7803,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4566,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 4135,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4047,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 3813,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 1905,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1476,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1432,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 616,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 340,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 317,
      "timestamp": "2023-03-02T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 83382,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 46351,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 31386,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 31359,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 25198,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 20637,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 20242,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 20152,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13188,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12018,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11819,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8258,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8096,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 7925,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 4628,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 4469,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4119,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4092,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2003,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1491,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1455,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 626,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 349,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 319,
      "timestamp": "2023-03-02T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 84559,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 46873,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 32414,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 32409,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 25888,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 21535,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 21210,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 20833,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13510,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12091,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 11874,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8322,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8256,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8078,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5013,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 4714,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4272,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4121,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2122,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1542,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1500,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 632,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 356,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T20:00:00-05:00",
      "votes": 319
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 86321,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 47699,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 33412,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 33203,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 26700,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 22604,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 22113,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21250,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13685,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12196,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12147,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8490,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8457,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8217,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5245,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 4930,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4575,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4149,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2179,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1622,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1545,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 636,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 366,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-02T21:00:00-05:00",
      "votes": 319
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 87615,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 48122,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 34273,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34236,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 27218,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 23080,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 23078,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21285,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13839,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12386,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12256,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8608,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8606,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8335,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5339,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5094,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4645,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4165,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2277,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1626,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1559,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 648,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 367,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 327,
      "timestamp": "2023-03-02T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 89683,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 48849,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35136,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34392,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28050,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 24154,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 23825,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21381,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13908,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12536,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12296,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8769,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8638,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8382,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5426,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5281,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4650,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4167,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2344,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T23:00:00-05:00",
      "votes": 1626
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1569,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 655,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 371,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 328,
      "timestamp": "2023-03-02T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90235,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 49100,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35263,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34483,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28315,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 24630,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 24473,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21409,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 13957,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12572,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12457,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8819,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8811,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8435,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5544,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5530,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4658,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4171,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2359,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1637,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1574,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 656,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 376,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 329,
      "timestamp": "2023-03-03T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90237,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 49477,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35303,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34497,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28347,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25322,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 24713,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21413,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14058,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12576,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12535,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8873,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8822,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8555,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5706,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5615,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T01:00:00-05:00",
      "votes": 4658
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4177,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2384,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1652,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1588,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 663,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 377,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T01:00:00-05:00",
      "votes": 329
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90240,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 49628,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35357,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34501,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28352,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25401,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 24916,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 21413
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14188,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 12576
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12539,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8889,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 8822
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8599,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5710,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5628,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4659,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4229,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2415,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1755,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1653,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 665,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 378,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 329
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 90240
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 50043,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35562,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34608,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28366,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25473,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 24944,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21414,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14206,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12596,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 12539
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8892,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8825,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8619,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5717,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5680,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4712,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4257,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2421,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1761,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 1653
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 666,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 379,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 329
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90241,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 50173,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35805,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34713,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28605,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25534,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 25185,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21422,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14215,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 12695,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12543,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8951,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 8943,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8716,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5719,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5703,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4714,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 4257
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2448,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1801,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1656,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 669,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 379
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 333,
      "timestamp": "2023-03-03T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90242,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 50206,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 35907,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 34917,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 28908,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25688,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 25562,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21424,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14239,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 13008,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12544,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9032,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 8965,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8721,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5732,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5708,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4717,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4259,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2463,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1823,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T05:00:00-05:00",
      "votes": 1656
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 670,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 380,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 340,
      "timestamp": "2023-03-03T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90363,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 50352,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 36045,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 35479,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 29386,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 26084,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 25898,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21487,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14438,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 13162,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12703,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 9192,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9065,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8790,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 5841,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5745,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 4918,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4270,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2480,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1915,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T06:00:00-05:00",
      "votes": 1656
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 680,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 381,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T06:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 90948,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 50666,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 36596,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 36340,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 30056,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 26360,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 26117,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21619,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14574,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 13474,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12803,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 9312,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9094,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8875,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6131,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5795,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5068,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4275,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2551,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1955,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1660,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 689,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 398,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 343,
      "timestamp": "2023-03-03T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 91789,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 51883,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 37055,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 36552,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 30400,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 26911,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 26554,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21647,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14729,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 13987,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 12944,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 9521,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9162,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 8996,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6175,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 5933,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5164,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4291,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2579,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 1986,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1664,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 696,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 406,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 358,
      "timestamp": "2023-03-03T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 94026,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 52242,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 37631,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 37188,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 30855,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 27457,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 26881,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21669,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 14962,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 14507,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 13077,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 9679,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9251,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 9190,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6486,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6096,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5188,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4304,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2641,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2062,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1713,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 722,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 408,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 369,
      "timestamp": "2023-03-03T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 96533,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 52498,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 38255,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 37699,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 31296,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 28014,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 27594,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21731,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 15402,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 14759,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 13158,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 9929,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 9389,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9336,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6647,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6170,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5263,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4313,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2729,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2105,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1776,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 737,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 450,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 376,
      "timestamp": "2023-03-03T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 97277,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 53122,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 38625,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 38424,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 31827,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 28867,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 28484,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21794,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 15757,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 15091,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 13373,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 10061,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 9636,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9397,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6859,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6240,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5289,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4323,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2866,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2133,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 1880,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 747,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 473,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 390,
      "timestamp": "2023-03-03T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 97516,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 53881,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 39502,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 38583,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 32389,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 30281,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 28759,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 21824,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 16284,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 15268,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 13769,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 10415,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 9761,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9468,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 6937,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6317,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5418,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4359,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 2955,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2178,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2063,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 762,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 474,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T12:00:00-05:00",
      "votes": 390
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 98334,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 54859,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 40585,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 38862,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 33075,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 31354,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 29173,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 22135,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 16583,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 15487,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14008,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 10498,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 10089,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9604,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 7045,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6374,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5516,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4368,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3056,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2325,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2077,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 780,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 478,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 392,
      "timestamp": "2023-03-03T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 99352,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 55497,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 41425,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 39333,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 33679,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 32702,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 29728,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 22160,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 16778,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 15789,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14097,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 10667,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 10200,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9650,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 7267,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6440,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5630,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4399,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3261,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2400,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2079,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 795,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 479,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 398,
      "timestamp": "2023-03-03T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 100648,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 55907,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 41680,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 39739,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 34470,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 33272,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 30191,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 22532,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 17179,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 16084,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14243,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 10784,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 10460,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9736,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 7434,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6478,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5717,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4434,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3487,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2434,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2084,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 814,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 498,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 400,
      "timestamp": "2023-03-03T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 101579,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 56955,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 41962,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 40204,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 35210,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 34198,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 30616,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 22938,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 17398,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 16194,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14295,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 11164,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 10879,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9810,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 7669,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6523,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5766,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4482,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3696,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2536,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2094,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 819,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 600,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 402,
      "timestamp": "2023-03-03T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 101719,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 57871,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 42340,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 40502,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 35626,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 35083,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 31012,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23009,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 17796,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 16384,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14392,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 11552,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 11077,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9838,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 7787,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6645,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 5842,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4549,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3793,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2574,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2099,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 829,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 604,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 403,
      "timestamp": "2023-03-03T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 103139,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 58793,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 43066,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 40784,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 37042,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 35864,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 31613,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23030,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 18244,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 16544,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14613,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 11716,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 11359,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9897,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8007,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6734,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6047,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4550,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3836,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2588,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2168,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 837,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 646,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T18:00:00-05:00",
      "votes": 403
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 103763,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 59645,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 43741,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 41304,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 37930,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 36997,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 32359,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23060,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 18445,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 16826,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14733,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 11828,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 11608,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 9941,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8134,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 6968,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6306,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4559,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3904,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2745,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2298,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 845,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 715,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 704,
      "timestamp": "2023-03-03T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 106657,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 60504,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 44921,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 41729,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 39086,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 37790,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 32763,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23112,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 18658,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 17379,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14769,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12043,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 11863,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10024,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8313,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 7254,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6355,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4591,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 3958,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2838,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2390,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 981,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 853,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 718,
      "timestamp": "2023-03-03T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 108682,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 61352,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 45619,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 42468,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 40355,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 38440,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 33469,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23214,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 18800,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 17662,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14807,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12288,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 12187,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10140,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8469,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 7518,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6390,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4607,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4022,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2880,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2595,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1162,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 867,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 723,
      "timestamp": "2023-03-03T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 109709,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 62028,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46122,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 42956,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 41137,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 39180,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 33599,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23231,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 19130,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 17870,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14819,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 12624,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12401,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10233,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8623,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 7675,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6431,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4666,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4190,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 2987,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2873,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1242,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 873,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 725,
      "timestamp": "2023-03-03T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 111844,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 62957,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46346,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 43547,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 41662,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 40060,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 33884,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23328,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 19614,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18210,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14850,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 12728,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12514,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10361,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8728,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 7934,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6461,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4696,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4295,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3064,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 2931,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1324,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 877,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 726,
      "timestamp": "2023-03-03T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 113355,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63214,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46382,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44026,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 41888,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 40458,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34175,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23410,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 19952,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18303,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14868,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 12938,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12525,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10451,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8753,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8108,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6476,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4715,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4311,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3187,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3067,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1338,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 880,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T00:00:00-05:00",
      "votes": 726
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 113820,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63364,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46390,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44195,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42031,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 40940,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34487,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23633,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20134,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18354,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14869,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13045,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12528,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10458,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8812,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8257,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6483,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4771,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4318,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3226,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3075,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1345,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 890,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 727,
      "timestamp": "2023-03-04T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 114211,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63463,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46438,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44362,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42101,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 41077,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34550,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23634,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20141,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18375,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14872,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13064,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12556,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10464,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8813,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8264,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6484,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4779,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4334,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3227,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3133,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1352,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 892,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T02:00:00-05:00",
      "votes": 727
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 114211
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63495,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46459,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44430,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42140,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 41216,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34564,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23635,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20165,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18821,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14873,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13078,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12558,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10465,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8814,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8287,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6504,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 4779
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4336,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 3227
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 3133
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1358,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 893,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 727
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 114570,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63722,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46625,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44639,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42300,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 41315,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34597,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T04:00:00-05:00",
      "votes": 23635
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20179,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18892,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14877,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13140,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T04:00:00-05:00",
      "votes": 12558
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10466,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T04:00:00-05:00",
      "votes": 8814
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8300,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6541,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T04:00:00-05:00",
      "votes": 4779
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4342,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3228,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3134,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1364,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 894,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 728,
      "timestamp": "2023-03-04T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 114901,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 63880,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 46731,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 44847,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42374,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 41415,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 34684,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23636,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20192,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 18902,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14878,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13143,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12560,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10472,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8846,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8327,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6576,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T05:00:00-05:00",
      "votes": 4779
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4366,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3234,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T05:00:00-05:00",
      "votes": 3134
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1373,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 896,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T05:00:00-05:00",
      "votes": 728
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 115282,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 64110,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 47511,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 45001,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 42903,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 41788,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 35021,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23641,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20341,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19096,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14898,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13151,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 12680,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10492,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8853,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8356,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6588,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4783,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4374,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T06:00:00-05:00",
      "votes": 3234
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3180,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1428,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 904,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 731,
      "timestamp": "2023-03-04T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 115538,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 64301,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 47679,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 45229,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 43395,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 42227,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 35360,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23643,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20472,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19161,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14907,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13263,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 13017,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10523,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 8856,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8419,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6596,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4815,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4400,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3293,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3237,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1623,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 916,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 796,
      "timestamp": "2023-03-04T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 116231,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 65047,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 47892,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 45671,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 44014,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 42915,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 35617,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23658,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20723,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19216,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14934,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13529,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 13286,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10571,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9017,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8489,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6647,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4880,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4437,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3581,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3304,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1719,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 976,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 805,
      "timestamp": "2023-03-04T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 117472,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 65445,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 48212,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 46194,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 44656,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 43295,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 35717,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23666,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 20935,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19361,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14966,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 13915,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13693,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10638,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9101,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8535,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6744,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4890,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4538,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3838,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3309,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1745,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 988,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 829,
      "timestamp": "2023-03-04T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 118002,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 65924,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 48710,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 46479,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 44956,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 43982,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 35865,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23689,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 21282,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19682,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 14988,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 14325,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 13820,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10674,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9125,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8741,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6782,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4910,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4653,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 3926,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3310,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1858,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 994,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 837,
      "timestamp": "2023-03-04T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 118735,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 66156,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 48896,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 46948,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 45406,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 44627,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 36116,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23747,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 21543,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19788,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15007,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 14636,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 14167,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10758,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9197,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8866,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6799,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4921,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4746,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4111,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3311,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 1916,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1008,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 848,
      "timestamp": "2023-03-04T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 120304,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 66648,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 49212,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 47065,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 46377,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 45427,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 36246,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23773,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 21937,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 19899,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15052,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 14872,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 14487,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10785,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9241,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 8892,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6813,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4926,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4871,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4345,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3314,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2139,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1019,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 954,
      "timestamp": "2023-03-04T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 121124,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 67036,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 49645,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 47312,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 47253,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 46322,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 36528,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23856,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 22113,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 20042,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15074,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 15005,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 14757,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10824,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9396,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9012,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6825,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4969,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 4909,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4609,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3317,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2204,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1046,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 956,
      "timestamp": "2023-03-04T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 121571,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 67534,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 50094,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 48422,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 47743,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 47199,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 36921,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23965,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 22632,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 20199,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 15331,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15129,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 14850,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10845,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9558,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9068,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6887,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5033,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 4974,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4732,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3323,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2230,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1066,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 964,
      "timestamp": "2023-03-04T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 121609,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 68199,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 51174,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 49269,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 48374,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 47885,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 37076,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 23986,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 23169,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 20479,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 15487,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15230,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 14981,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10869,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9761,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9215,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6920,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5194,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5040,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4783,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3416,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2403,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1113,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1005,
      "timestamp": "2023-03-04T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 121808,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 68887,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 52454,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 50095,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 48862,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 48519,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 37278,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 24073,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 23751,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 20658,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 15757,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15297,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 15118,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10891,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 9939,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9315,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 6934,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5265,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5079,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 4928,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3420,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2452,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1131,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1116,
      "timestamp": "2023-03-04T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 121825,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 69357,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 52755,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 50707,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 49408,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 49364,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 37468,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 24486,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 24414,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 20880,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 15902,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15529,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 15347,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10907,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 10267,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9387,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7010,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5436,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 5162,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5111,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3421,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2505,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1187,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1145,
      "timestamp": "2023-03-04T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 122037,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 69759,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 53270,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 51431,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 50151,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 49818,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 37605,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 25032,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 24689,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21112,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 16091,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15753,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 15541,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 10960,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 10490,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9500,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7038,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5483,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 5315,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5152,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3436,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2521,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1287,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1159,
      "timestamp": "2023-03-04T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 122082,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 70395,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 53627,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 52451,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 50847,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 50264,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 37808,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 25300,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 24936,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21256,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 16331,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15818,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 15812,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11009,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 10562,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9569,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7180,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5600,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 5432,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5220,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3437,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2560,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1301,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1170,
      "timestamp": "2023-03-04T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 122322,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 70843,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 55834,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 53643,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 51843,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 50924,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 38488,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 25598,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 25195,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21480,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 16517,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 16057,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15826,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11084,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 10639,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9672,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7217,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5709,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 5672,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5242,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3484,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2595,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1351,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1186,
      "timestamp": "2023-03-04T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 123022,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 71840,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 56388,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 54488,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 52717,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 51543,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 39282,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 25834,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 25756,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21693,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 16748,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 16214,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15840,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11152,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 10805,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9744,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7232,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5907,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 5890,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5273,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3519,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2663,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1361,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1197,
      "timestamp": "2023-03-04T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 123252,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 73414,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 56895,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 55039,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 53622,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 51864,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 39848,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 26578,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 26388,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21830,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 17057,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 16595,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 15938,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11280,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11169,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 9958,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7249,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6137,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5961,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5296,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3528,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2680,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1370,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1206,
      "timestamp": "2023-03-04T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 123262,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 73943,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 57018,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 55306,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 54418,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52351,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40362,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 27308,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 26681,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 21936,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 17322,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 16971,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16057,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11514,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11189,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10130,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7258,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6331,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5967,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5319,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3533,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2709,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1375,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1220,
      "timestamp": "2023-03-04T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 123461,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 74658,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 57046,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 55713,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 54929,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52500,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40480,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28004,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 26739,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22006,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 17489,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17202,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16125,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11669,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11216,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10166,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7265,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6529,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 5974,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5330,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3535,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2711,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1376,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1222,
      "timestamp": "2023-03-05T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 124014,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 74804,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 57179,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56095,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55223,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52573,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40498,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28156,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 26753,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22018,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 17725,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17358,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16206,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11687,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11244,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10370,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7269,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6555,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6131,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5336,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3537,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2713,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T01:00:00-05:00",
      "votes": 1376
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1223,
      "timestamp": "2023-03-05T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 124039,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 74824,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 57413,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56348,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55365,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52632,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40544,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28301,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27061,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22063,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 17909,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17416,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16212,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11692,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11245,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10402,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T02:00:00-05:00",
      "votes": 7269
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6594,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6138,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T02:00:00-05:00",
      "votes": 5336
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3539,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2714,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1377,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1225,
      "timestamp": "2023-03-05T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 124040,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 74849,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 59546,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56436,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55388,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52687,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40547,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28346,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27073,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22102,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18109,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17417,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16217,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11696,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11246,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10404,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7270,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6614,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6188,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5338,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T03:00:00-05:00",
      "votes": 3539
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2715,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T03:00:00-05:00",
      "votes": 1377
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1227,
      "timestamp": "2023-03-05T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 124040
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 74887,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 60005,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56515,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55509,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52772,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40591,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28400,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27074,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 22102
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18225,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17569,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16229,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11701,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11247,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10406,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 7270
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6616,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 6188
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5351,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3551,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2716,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1383,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1254,
      "timestamp": "2023-03-05T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 124042,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 75051,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 60094,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56548,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55561,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52786,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40605,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28410,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27090,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22165,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 18225
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17673,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16230,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 11701
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11250,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10409,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7271,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6681,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6193,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5353,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3552,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 2716
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 1383
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1262,
      "timestamp": "2023-03-05T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T06:00:00-05:00",
      "votes": 124042
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 75091,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 60261,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 56778,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55662,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 52886,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40641,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28412,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27123,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22235,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18232,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17781,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16232,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11702,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11253,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10417,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7273,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6708,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6199,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5354,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T06:00:00-05:00",
      "votes": 3552
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2732,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1390,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1267,
      "timestamp": "2023-03-05T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T07:00:00-05:00",
      "votes": 124042
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 75269,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 61578,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 57293,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 55872,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 53049,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 40859,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28562,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27210,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22332,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18236,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 17833,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16233,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11705,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11262,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10453,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7276,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 6782,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6272,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5359,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T07:00:00-05:00",
      "votes": 3552
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2743,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T07:00:00-05:00",
      "votes": 1390
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1279,
      "timestamp": "2023-03-05T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 124200,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 75725,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 62564,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 57647,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 56294,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 53243,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41177,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28681,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27237,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22444,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18368,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 18112,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16257,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 11823,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11284,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10524,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7304,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 7152,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6293,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5418,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3600,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2753,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1397,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1296,
      "timestamp": "2023-03-05T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 125404,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 76371,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 63026,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 58179,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 56822,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 53568,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41236,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 28897,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27358,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22478,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 18477,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18435,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16263,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12054,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11290,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10569,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7455,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 7439,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6329,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5444,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3602,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2763,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1438,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1311,
      "timestamp": "2023-03-05T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 126271,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 76665,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 63771,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 58772,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 57215,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 53833,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41455,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 29297,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27474,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22603,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 18819,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18544,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16271,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12113,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11300,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10602,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 7549,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7464,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6375,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5476,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3605,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2783,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1445,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1344,
      "timestamp": "2023-03-05T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 126612,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 77228,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 64186,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 59411,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 57919,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54097,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41708,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 29440,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27545,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22848,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19110,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18614,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16276,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12139,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11345,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10680,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 7715,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7470,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6403,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5506,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3608,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2829,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1453,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1373,
      "timestamp": "2023-03-05T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 126705,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 78015,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 64361,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 59936,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 58415,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54268,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41803,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 29806,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27564,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 22943,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19387,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18635,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16282,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12225,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11366,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10812,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 7909,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7523,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6427,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5510,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3609,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2840,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1455,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1408,
      "timestamp": "2023-03-05T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 127416,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 78733,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 64511,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 60324,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 58895,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54348,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 41961,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 30216,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27567,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23024,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19522,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 18811,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16297,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12253,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11393,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 10953,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 8256,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7662,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6496,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5517,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3618,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2859,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1464,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1456,
      "timestamp": "2023-03-05T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 128105,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 79251,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 64707,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 60926,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 59297,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54469,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 42181,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 30312,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27656,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23145,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19658,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19007,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16327,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12340,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11422,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 11049,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 8498,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7716,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6506,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5522,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3629,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2885,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1501,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1457,
      "timestamp": "2023-03-05T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 128432,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 79947,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 64881,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 61730,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 59703,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54642,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 42410,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 30746,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27720,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23221,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19780,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19056,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16452,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12425,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11436,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 11365,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 8732,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7727,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6562,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5550,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3630,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2936,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1529,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1465,
      "timestamp": "2023-03-05T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 128584,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 80787,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 65122,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 62502,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 60425,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 54837,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 42664,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 30900,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27727,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23350,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 19988,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19097,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16573,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12622,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 11873,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11456,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 9000,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7796,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6601,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5584,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3639,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2977,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1546,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1472,
      "timestamp": "2023-03-05T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 131341,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 81468,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 65351,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 63206,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 61029,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 55259,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 42932,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 31007,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27865,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23583,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 20179,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19158,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16797,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 12922,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 12070,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11464,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 9590,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7822,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6632,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5642,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3648,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2984,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1657,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T17:00:00-05:00",
      "votes": 1472
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 131848,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 82223,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 65556,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 63882,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 61716,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 55458,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 43131,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 31510,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 27964,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 23829,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 20392,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19197,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16882,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 13399,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 12228,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11489,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 9821,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7897,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6691,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5658,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3649,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2986,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1677,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1475,
      "timestamp": "2023-03-05T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 131867,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 82951,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 67167,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 64637,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 62196,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 55775,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 43303,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 31847,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 28542,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 24069,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 20856,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19276,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16931,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 13613,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 12374,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11511,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 10303,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 7966,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6847,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5755,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3650,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 2994,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1738,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1500,
      "timestamp": "2023-03-05T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 133244,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 83713,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 68633,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 65886,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 62982,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 56309,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 43527,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32066,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 28565,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 24245,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 21559,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19425,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 16953,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 13770,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13071,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11534,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 10625,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8058,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6869,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5798,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3656,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3030,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1806,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1504,
      "timestamp": "2023-03-05T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 134468,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 84297,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 69538,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 67249,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 63874,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 56840,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44033,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32252,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 28983,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 24547,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 21811,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19452,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17003,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14016,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13277,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11552,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 11314,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8269,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6894,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5841,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3662,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3065,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1853,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T21:00:00-05:00",
      "votes": 1504
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 135290,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 85173,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 70169,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 67795,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 64518,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57217,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44206,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32711,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29135,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 24927,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22019,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19467,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17040,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14161,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13446,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 11583,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11569,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8367,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 6969,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5879,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3664,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3083,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1884,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1505,
      "timestamp": "2023-03-05T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136083,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 85357,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 71335,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 68594,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65033,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57440,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44327,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32819,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29172,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25040,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22335,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19470,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17073,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14217,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13464,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 11736,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11594,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8395,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7160,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5883,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3665,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3085,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1908,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1509,
      "timestamp": "2023-03-05T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136091,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 85563,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 72264,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 68868,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65164,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57547,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44400,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32831,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29410,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25042,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22539,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19525,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17076,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14221,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13491,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12002,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11605,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8409,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7209,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5885,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3666,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3092,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1919,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T00:00:00-05:00",
      "votes": 1509
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 136091
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 85949,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 72651,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69030,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65184,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57607,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44407,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32843,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29412,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25043,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22657,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19532,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17080,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14241,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13545,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12178,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11607,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8412,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7222,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 5885
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 3666
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3094,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1924,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 1509
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T02:00:00-05:00",
      "votes": 136091
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86141,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 72655,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69088,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65233,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57630,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44455,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32854,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29543,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25058,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22735,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19558,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17081,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14248,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13650,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12217,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11610,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8413,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7224,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5886,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3667,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3095,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1929,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T02:00:00-05:00",
      "votes": 1509
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136092,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86227,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 72880,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69237,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65285,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57683,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44503,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32868,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 29543
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25086,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22742,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19559,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17085,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14276,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13652,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12254,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11611,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8433,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7225,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5889,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 3667
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3096,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1930,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 1509
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 136092
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86248,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 73129,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69515,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65365,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57710,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44724,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32869,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29545,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25098,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22763,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19561,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17086,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14285,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13654,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12273,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 11611
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8434,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7226,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5907,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 3667
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 3096
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1932,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 1509
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 136092
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86303,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 74623,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69582,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65427,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57718,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44860,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 32990,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29546,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25113,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22813,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19564,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17088,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14286,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13693,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12367,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11612,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8438,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7253,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5910,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 3667
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3099,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1941,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1510,
      "timestamp": "2023-03-06T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136094,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86507,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 75532,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 69738,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65574,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57761,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 44994,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33035,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29571,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25141,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 22862,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19573,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17089,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14287,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13729,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12510,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11615,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8447,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7278,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5915,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3684,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3124,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 1989,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1514,
      "timestamp": "2023-03-06T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136440,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86632,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 76105,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 70223,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 65806,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57888,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45078,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33065,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29574,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25245,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 23025,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19703,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17100,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14291,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13741,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12729,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11631,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8465,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7440,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5928,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3687,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3134,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2009,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1559,
      "timestamp": "2023-03-06T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 136867,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 86861,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 77111,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 70655,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 66164,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 57986,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45102,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33157,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29586,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25559,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 23191,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 19750,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17108,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14354,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 13820,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 12880,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11673,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8565,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7486,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5932,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3694,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3164,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2030,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1588,
      "timestamp": "2023-03-06T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 137470,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 87543,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 77539,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 71089,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 66513,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 58280,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45169,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33233,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29601,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 25722,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 23368,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20038,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17140,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14526,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 14030,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 13089,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11689,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8578,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7582,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5938,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3696,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3195,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2062,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1631,
      "timestamp": "2023-03-06T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 138240,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 88092,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 79444,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 71604,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 66822,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 58744,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45327,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33769,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29622,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26024,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 23619,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20258,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17355,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14573,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 14518,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 13338,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11730,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8617,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7807,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5950,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3717,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3225,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2098,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1641,
      "timestamp": "2023-03-06T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 138868,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 88503,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 80780,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 72038,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 67465,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 59122,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45388,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 33947,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29633,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26271,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 23811,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20294,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17454,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 14896,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14666,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 13805,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11788,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8662,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 7961,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5955,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3729,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3270,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2136,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1650,
      "timestamp": "2023-03-06T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 139556,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 88723,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 80955,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 72741,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 67831,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 59317,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45580,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34055,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29693,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26447,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24001,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20422,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17519,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 15237,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 14952,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 14235,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11889,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8681,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 8167,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5967,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3778,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3335,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2156,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1660,
      "timestamp": "2023-03-06T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 139712,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 89388,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 81181,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 73196,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 68602,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 59746,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45628,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34522,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29759,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26639,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24174,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20559,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17537,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 15403,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 15262,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 14553,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 11942,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8687,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 8360,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5973,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3852,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3351,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2174,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1672,
      "timestamp": "2023-03-06T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 140053,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 89871,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 82350,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 73542,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 69435,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 60070,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 45727,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34601,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 29826,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26816,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24254,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 20747,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17569,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 15654,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 15350,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 14749,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12023,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8757,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 8548,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5977,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3853,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3366,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2189,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1682,
      "timestamp": "2023-03-06T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 140500,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 90215,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 84270,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 73964,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 70365,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 60258,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46012,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34728,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 30034,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 26939,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24346,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21010,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17623,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 15870,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 15546,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 15082,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12088,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 8890,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8790,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 5984,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3858,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3388,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2202,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1705,
      "timestamp": "2023-03-06T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 140535,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 91057,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 84934,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 75175,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 71069,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 60596,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46201,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34847,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 30088,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27043,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24533,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21090,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17800,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 16115,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 15741,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 15499,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12143,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9043,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 8845,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6023,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3872,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3430,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2229,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1841,
      "timestamp": "2023-03-06T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 141085,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 92061,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 85210,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 76061,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 71918,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 61004,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46336,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 34960,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 30141,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27259,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 24815,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21151,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 17956,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 16351,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 16117,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 16060,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12199,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9097,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9026,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6048,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3898,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3443,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2283,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 1981,
      "timestamp": "2023-03-06T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 141134,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 93019,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 86400,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 76998,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 72717,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 61248,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46425,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 35176,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 30155,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27449,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25056,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21240,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18041,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 16641,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 16551,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 16379,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12226,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9286,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9203,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6130,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3953,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3454,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2326,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2041,
      "timestamp": "2023-03-06T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 141466,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 93889,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 88720,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 78079,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 73444,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 61560,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46574,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 35557,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 35119,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27579,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25280,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21274,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18064,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 17379,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 17121,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 16546,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12259,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9433,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9382,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6241,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3977,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3464,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2346,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2042,
      "timestamp": "2023-03-06T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 144648,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 95073,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 89145,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 79107,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 74464,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 62117,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 46717,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 42508,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 35889,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27715,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25429,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21361,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18162,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 17979,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 17482,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 16699,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12374,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9656,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9576,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6406,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 3978,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3483,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2387,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2049,
      "timestamp": "2023-03-06T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 146771,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 96003,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 89723,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 79942,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 75095,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 62687,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47173,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44350,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 36352,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 27974,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25624,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21459,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 18583,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18230,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 17834,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 16920,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12389,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9880,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9678,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6479,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4008,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3488,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2475,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2054,
      "timestamp": "2023-03-06T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 147504,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 96871,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 89804,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 80809,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 75704,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63088,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47389,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44430,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 37152,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28461,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 25796,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21528,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 19371,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 18554,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18333,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17269,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12420,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 9927,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9819,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6536,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4044,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3496,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2695,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2063,
      "timestamp": "2023-03-06T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 149258,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 97720,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 89839,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81225,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 76152,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63361,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47518,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44570,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 38075,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28550,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26035,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21581,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 19902,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 18836,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18550,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17645,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12454,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10020,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9874,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6599,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4048,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3502,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2740,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2067,
      "timestamp": "2023-03-06T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 150337,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 97951,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 89953,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81527,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 76317,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63484,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47651,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44852,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 38735,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28578,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26172,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21606,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20096,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 18999,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18602,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17751,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12468,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10044,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9905,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6626,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4066,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3507,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2779,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2077,
      "timestamp": "2023-03-07T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T01:00:00-05:00",
      "votes": 150337
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 98402,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 90026,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81660,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 76721,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63518,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47674,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44861,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39056,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28586,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26182,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21638,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20206,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19027,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18604,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17775,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12477,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10052,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9909,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6629,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4087,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3508,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2792,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2078,
      "timestamp": "2023-03-07T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 150338,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 98527,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 90282,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81692,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 76972,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63521,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47747,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44862,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39069,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28593,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26254,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21640,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20214,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19077,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18613,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17794,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12483,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10054,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9913,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6631,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4095,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-07T02:00:00-05:00",
      "votes": 3508
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T02:00:00-05:00",
      "votes": 2792
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2079,
      "timestamp": "2023-03-07T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 150338
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 98651,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 90434,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81763,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 77065,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63592,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47834,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44863,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39071,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28608,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26314,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21641,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20220,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19083,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18721,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17797,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 12483
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10059,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9914,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6650,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 4095
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 3508
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2798,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 2079
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 150338
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 98870,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 93024,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 81934,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 77131,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63605,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47871,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44864,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39231,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28717,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26427,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 21641
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20260,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19094,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18722,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17800,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12488,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10121,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 9914
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6670,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 4095
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3573,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2820,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 2079
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 150339,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 98939,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 93090,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 82162,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 77184,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63733,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 47913,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44870,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39401,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28802,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26586,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21642,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20343,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19122,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T05:00:00-05:00",
      "votes": 18722
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17866,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12492,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10123,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9926,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6673,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4096,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3632,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 2864,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2080,
      "timestamp": "2023-03-07T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 150342,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 99267,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 93320,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 82340,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 77360,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63823,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 48091,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44874,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39532,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28862,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26677,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21651,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20422,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19192,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18736,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17888,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12510,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10142,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9932,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6691,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4098,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3649,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3000,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2081,
      "timestamp": "2023-03-07T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 150978,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 99503,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 93412,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 82602,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 77870,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 63959,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 48222,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44909,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 39819,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 28950,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 26785,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21694,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 20848,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19257,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18760,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 17921,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12524,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10177,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 9953,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6746,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T07:00:00-05:00",
      "votes": 4098
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3655,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3043,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2083,
      "timestamp": "2023-03-07T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 151151,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 100029,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 94434,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 82885,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 78208,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 64136,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 48302,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44923,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 40447,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 29230,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 27029,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21863,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 21308,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19377,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18768,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 18027,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12534,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10239,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10052,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6767,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4120,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3713,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3081,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2120,
      "timestamp": "2023-03-07T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 152039,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 101222,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 96400,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 83200,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 79299,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 64311,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 48537,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44942,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 41127,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 29614,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 27126,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21896,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 21884,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19523,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 18871,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 18228,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12566,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10364,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10139,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6798,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4124,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3773,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3096,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2125,
      "timestamp": "2023-03-07T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 154019,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 102170,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 96747,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 83751,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 80103,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 64619,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 48775,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 44981,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 41427,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 29913,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 27309,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 22357,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 21948,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19682,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19028,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 18393,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12596,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10464,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10193,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6827,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4129,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3897,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3153,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2129,
      "timestamp": "2023-03-07T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 155621,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 103129,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 96958,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 84222,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 81151,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 64937,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 49083,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45024,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 41615,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30068,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 27597,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 22841,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22027,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19812,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19199,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 18506,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12619,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10557,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10327,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6874,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4134,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 3960,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3178,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2134,
      "timestamp": "2023-03-07T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 156112,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 103904,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 99178,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 84971,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 81947,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 65202,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 49820,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45035,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 41742,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30229,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 28074,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 23341,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22095,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19862,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19265,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 19101,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12647,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10707,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10407,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 6998,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4161,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4008,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3188,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2150,
      "timestamp": "2023-03-07T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 156641,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 104333,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 100518,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 85788,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 82718,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 65513,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 50743,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45048,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 42269,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30335,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 28221,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 23688,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22162,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 19978,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 19624,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19294,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12701,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 10891,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10528,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7074,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4264,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4206,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3218,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2168,
      "timestamp": "2023-03-07T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 157063,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 104683,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 100813,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 86324,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 83933,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 65760,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 51053,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45066,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 42865,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30581,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 28486,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 24648,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22280,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 20416,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 20320,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19313,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12723,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11233,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10759,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7122,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4370,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4207,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3225,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2171,
      "timestamp": "2023-03-07T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 157768,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 105474,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 101540,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 86998,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 84926,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 66072,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 51568,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45070,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 43500,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30691,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 28665,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 24985,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22398,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 21304,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 20798,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19324,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12745,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11315,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10827,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7129,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4411,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4236,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3238,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2181,
      "timestamp": "2023-03-07T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 159843,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 105861,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 103531,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 87635,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 85696,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 66327,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52029,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45123,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 43948,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 30873,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 28823,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 25136,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22466,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 21810,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 21070,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19495,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12796,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11454,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 10944,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7197,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4456,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4243,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3247,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2185,
      "timestamp": "2023-03-07T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 160599,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 106449,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 104510,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 88073,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 86324,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 66863,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52130,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45410,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 45059,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 31044,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 29041,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 25435,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22560,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22055,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 21337,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19572,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12814,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11682,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11071,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7239,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4522,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4247,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3295,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2188,
      "timestamp": "2023-03-07T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 161745,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 107585,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 104871,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 88528,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 87172,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 67163,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52325,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 45968,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 45621,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 31185,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 29272,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 25820,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22617,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22160,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 21622,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19623,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12839,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 11910,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11083,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7264,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4557,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4353,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3311,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2191,
      "timestamp": "2023-03-07T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 162796,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 108139,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 106979,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 89481,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 88109,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 67327,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52505,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 46973,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46002,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 31250,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 29417,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 26253,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22773,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22254,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 21776,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19670,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12868,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 12197,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11231,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7330,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4571,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4355,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3330,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2210,
      "timestamp": "2023-03-07T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 163953,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 109248,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 108198,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 90671,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 89448,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 67676,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52727,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 47497,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46212,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 31503,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 29594,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 26723,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22898,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22352,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 22106,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19688,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12886,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 12410,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11343,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7363,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4665,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4411,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3372,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2217,
      "timestamp": "2023-03-07T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 165554,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 110524,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 109948,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 92277,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 90720,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 68062,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 52902,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 48371,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46268,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32093,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 29856,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 27301,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 22992,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22419,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 22389,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19744,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12925,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 12558,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11389,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7438,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4725,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4488,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3388,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2233,
      "timestamp": "2023-03-07T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 167800,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 111345,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 111310,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 93599,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 91305,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 68549,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53174,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 48745,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46365,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32389,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 30344,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 27824,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23125,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 22723,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 22585,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19772,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13027,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12962,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11403,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7493,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4734,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4494,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3413,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2255,
      "timestamp": "2023-03-07T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 169448,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 112352,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 111784,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 94637,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 91509,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 68925,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53432,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49398,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46445,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32537,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 30712,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 28731,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 23583,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23281,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 22913,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19782,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13219,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12976,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11414,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7497,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4789,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4499,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3421,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2257,
      "timestamp": "2023-03-07T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 170363,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 113439,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 112177,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95124,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 91703,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69094,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53506,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49533,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46455,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32615,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 30925,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29362,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 23869,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23324,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23047,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19787,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13359,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12983,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11415,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7519,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4790,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T00:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3429,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2258,
      "timestamp": "2023-03-08T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 171081,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 113846,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 113029,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95201,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 91978,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69279,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53540,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49616,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46460,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32631,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 30939,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29494,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 23946,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23331,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23145,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19801,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13373,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12985,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11416,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7522,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4795,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T01:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3439,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2259,
      "timestamp": "2023-03-08T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 171087,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 114519,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 114280,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95259,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 92060,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69432,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53600,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49709,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46473,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32640,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31043,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29591,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24044,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23392,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23159,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19802,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13391,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T02:00:00-05:00",
      "votes": 12985
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11418,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7534,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4808,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T02:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3451,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2260,
      "timestamp": "2023-03-08T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 171087
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 114680,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 114667,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95260,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 92087,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69479,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53602,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49750,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 46473
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32712,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31076,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29864,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24061,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23460,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 23159
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19841,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13394,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12990,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 11418
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7541,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 4881,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3569,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 2260
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 171087
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 114903,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 114775,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95379,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 92181,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69566,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53605,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49781,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46476,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32735,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31192,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29880,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24063,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 23460
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23167,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19850,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13416,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 12990
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11421,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7543,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5002,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3660,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 2260
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T05:00:00-05:00",
      "votes": 171087
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 115281,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 115159,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 95729,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 92510,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 69658,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53640,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49786,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46481,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32784,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31306,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 29946,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24065,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T05:00:00-05:00",
      "votes": 23460
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23325,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19854,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13424,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 12994,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11454,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7545,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5008,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T05:00:00-05:00",
      "votes": 4499
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3672,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T05:00:00-05:00",
      "votes": 2260
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 171372,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 118451,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 115316,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 96284,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 92737,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 70005,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53721,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 49845,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46536,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32835,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31384,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 30105,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24073,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23504,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T06:00:00-05:00",
      "votes": 23460
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19857,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13503,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13000,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11547,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7548,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5030,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4500,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3705,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2261,
      "timestamp": "2023-03-08T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 172025,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 119231,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 116128,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 96621,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 93306,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 70161,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 53801,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 50137,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46572,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 32910,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31598,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 30476,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24154,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23631,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23553,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19867,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13612,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13008,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11557,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7556,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5047,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4537,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3710,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2342,
      "timestamp": "2023-03-08T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 175101,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 120030,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 117016,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 96937,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 93936,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 70356,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 54084,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 50354,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46665,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 33175,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31836,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 30834,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 24344,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 23753,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23705,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19904,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13682,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13026,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11584,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7576,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5076,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4610,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3733,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2352,
      "timestamp": "2023-03-08T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 177291,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 122372,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 118047,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 97511,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 94360,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 70616,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 54466,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 50615,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46731,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 33326,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 31971,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 31176,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 25119,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24026,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23768,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 19970,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13791,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13042,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11696,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7612,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5107,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4612,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3746,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2353,
      "timestamp": "2023-03-08T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 177836,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 123075,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 118888,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 98065,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 94843,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 70804,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 54731,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 50810,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46775,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 33539,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 32207,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 31644,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 26020,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24334,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23820,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20065,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 13930,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13073,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11734,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7645,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5124,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4613,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3753,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2381,
      "timestamp": "2023-03-08T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 181190,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 123402,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 119462,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 98552,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 95357,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 71078,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 54913,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 51216,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 46889,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 33841,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 33135,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 32517,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 26254,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24501,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 23953,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20168,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 14159,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13110,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11784,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7673,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5164,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4617,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3756,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2418,
      "timestamp": "2023-03-08T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 182555,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 124874,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 120437,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 99164,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 96091,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 71460,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 55105,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 51465,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 47524,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 34201,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 34153,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 32892,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 26732,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24660,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24059,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20398,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 14335,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13251,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11819,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7682,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5226,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4620,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3782,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2433,
      "timestamp": "2023-03-08T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 183425,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 127371,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 121262,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 99481,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 97088,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 71762,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 55301,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 51681,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 47627,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 35405,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 34585,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 33295,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 27883,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24852,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24178,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20483,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 14548,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13399,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11861,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7694,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5289,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4640,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3813,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2445,
      "timestamp": "2023-03-08T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 185659,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 128371,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 122683,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 100033,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 98140,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 72040,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 55473,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 51871,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 47917,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 36643,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 34932,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 33571,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 28632,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 24997,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24211,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20622,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 14731,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13484,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11876,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7699,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5320,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4643,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3913,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2463,
      "timestamp": "2023-03-08T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 187252,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 129165,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 123885,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 100958,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 98942,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 72240,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 55727,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 51997,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48007,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 37708,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 35299,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 33882,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 28812,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25089,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24223,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 20797,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 14794,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13576,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11886,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7704,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5412,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4644,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3926,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2470,
      "timestamp": "2023-03-08T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 188483,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 131770,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 125184,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 101690,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 99800,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 72543,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 56121,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 52287,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48129,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 38482,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 35534,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 34515,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 28858,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25248,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24287,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21049,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15004,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13647,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11893,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7724,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5434,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4649,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3934,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2482,
      "timestamp": "2023-03-08T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 190229,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 132437,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 126125,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 102260,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 101588,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 73085,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 56284,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 52456,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48158,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 39317,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 35848,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 34968,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 29126,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25449,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24318,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21084,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15170,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13785,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11927,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7774,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5439,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4650,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3949,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2489,
      "timestamp": "2023-03-08T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 191857,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 133624,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 126877,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 103478,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 102960,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 73291,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 56561,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 52685,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48184,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 40062,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 36193,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 35536,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 29346,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25639,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24357,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21136,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15300,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13812,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 11944,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7799,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5446,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4665,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 3961,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2511,
      "timestamp": "2023-03-08T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 192497,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 136050,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 128073,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 105297,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 104074,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 73451,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 56823,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 53130,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48214,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 40929,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 36541,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 35804,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 29548,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25744,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24364,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21202,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15435,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13847,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12064,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7863,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5476,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4691,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4022,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2529,
      "timestamp": "2023-03-08T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 194969,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 138314,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 129157,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 106882,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 106031,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 73688,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57245,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 53542,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48295,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 41834,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 36714,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 36403,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 29872,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 25970,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24399,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21252,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15647,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13904,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12168,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 7989,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5485,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4750,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4059,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2536,
      "timestamp": "2023-03-08T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 197392,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 139444,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 130492,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 109785,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 108333,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74059,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57434,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54137,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48341,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 43236,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 37205,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 37126,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30123,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26237,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24444,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21362,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15801,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13940,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12274,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8102,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5495,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4912,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4133,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2555,
      "timestamp": "2023-03-08T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 198392,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 140965,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 131741,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 111962,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 109500,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74248,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57693,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54560,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48429,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 44432,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 37915,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 37535,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30240,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26522,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24569,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21434,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 15975,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13981,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12289,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8129,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5506,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4959,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4258,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2558,
      "timestamp": "2023-03-08T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 199397,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 141339,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 132636,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 113394,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 110440,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74378,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57876,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54665,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48518,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 45519,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 38411,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 37688,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30351,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26647,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24582,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21451,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16062,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 13997,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12298,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8163,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5526,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4962,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4366,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2580,
      "timestamp": "2023-03-08T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 200512,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 141369,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 133068,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 114023,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 110883,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74442,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 57928,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54712,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48620,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46025,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 38713,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 37787,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30378,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26742,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24610,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21502,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16123,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14025,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12301,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8183,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-09T00:00:00-05:00",
      "votes": 5526
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4965,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4421,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2583,
      "timestamp": "2023-03-09T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 200513,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 142633,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 133771,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 114348,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 111208,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74550,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58004,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54723,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48659,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46182,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 38929,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 37915,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30401,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26743,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24614,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21504,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16213,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14027,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12302,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8202,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5527,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4966,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4472,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T01:00:00-05:00",
      "votes": 2583
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T02:00:00-05:00",
      "votes": 200513
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 144699,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134013,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 114534,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 111376,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74645,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58021,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54769,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48663,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46515,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39006,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38001,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30420,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26752,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24616,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21506,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16233,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14029,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T02:00:00-05:00",
      "votes": 12302
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8205,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-09T02:00:00-05:00",
      "votes": 5527
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4967,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4526,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2586,
      "timestamp": "2023-03-09T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 200515,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 144961,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134113,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 114702,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 111417,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74665,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58031,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 54801,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48665,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46666,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39088,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38015,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30433,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26882,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24617,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T03:00:00-05:00",
      "votes": 21506
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16240,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14031,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T03:00:00-05:00",
      "votes": 12302
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8207,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5690,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4968,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4527,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2587,
      "timestamp": "2023-03-09T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 200521,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 145049,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134208,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 115015,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 111503,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74717,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58066,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55026,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48671,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 46813,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39135,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38090,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30457,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26886,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 24617
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 21506
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16245,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14036,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12306,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8218,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5804,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4978,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4560,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 2587
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 200522,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 147380,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134352,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 115228,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 111783,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74757,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58086,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55135,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48736,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 47030,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39282,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38300,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30513,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26905,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24626,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T05:00:00-05:00",
      "votes": 21506
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16267,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14043,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12309,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8306,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5807,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 4979,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4567,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T05:00:00-05:00",
      "votes": 2587
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 201126,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 147910,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134715,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 116082,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 112063,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74832,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58237,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55266,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 48902,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 47219,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39343,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38362,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30516,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 26962,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24631,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21520,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16299,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14056,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12313,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8413,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5819,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5001,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4593,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2590,
      "timestamp": "2023-03-09T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 201863,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 148658,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 134961,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 116817,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 112606,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 74993,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58321,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55412,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49003,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 47393,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 39690,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38513,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30523,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27060,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24640,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21525,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16365,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14075,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12356,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8424,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5820,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5126,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4677,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2597,
      "timestamp": "2023-03-09T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 202550,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 148952,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 135579,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 117528,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 113474,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 75247,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58576,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55554,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49076,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 48205,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 40033,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 38672,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30631,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27133,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24650,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21531,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16477,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14167,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12429,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8445,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5829,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5131,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4909,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2619,
      "timestamp": "2023-03-09T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 205516,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 151041,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 137193,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 118818,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 114106,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 75389,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 58865,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 55780,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49119,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 49089,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 40246,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 39100,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 30863,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27367,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24656,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21606,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16571,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14384,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12453,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8453,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5867,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5140,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4952,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2622,
      "timestamp": "2023-03-09T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 206793,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 153747,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 138287,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 120132,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 114633,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 75543,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 59124,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 56118,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 49863,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49159,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 40682,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 39517,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 31274,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27508,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24673,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21700,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16607,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14481,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12486,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8463,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5907,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5156,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 4991,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2623,
      "timestamp": "2023-03-09T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 208536,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 153979,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 139502,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 121197,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 115184,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 75809,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 59801,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 56364,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 51255,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49217,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 41336,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 39915,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 31548,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27717,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24692,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 21873,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16615,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14615,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12557,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8477,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 5992,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5160,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5040,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2626,
      "timestamp": "2023-03-09T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 210578,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 155175,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 140387,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 122826,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 116175,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76066,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 60807,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 56708,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 51972,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49313,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 41840,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 40251,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 31682,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27815,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24701,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22005,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16649,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14676,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12562,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8494,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6034,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5181,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5047,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2628,
      "timestamp": "2023-03-09T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 212888,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 157912,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 141076,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 124133,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 117190,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76254,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 61196,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 56915,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 52520,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49408,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 42583,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 40527,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 31878,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27877,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24717,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22091,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16742,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14730,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12569,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8511,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6044,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5187,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5098,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2642,
      "timestamp": "2023-03-09T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 214866,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 158665,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 142150,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 125227,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 118133,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76435,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 61750,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 57058,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 53114,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49436,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 43251,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 40681,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 32031,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 27960,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24721,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22155,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16786,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14762,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12578,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8546,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6078,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5198,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5185,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2651,
      "timestamp": "2023-03-09T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 215891,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 158931,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 143364,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 126384,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 118614,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76615,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 62074,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 57433,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 53831,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49560,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 43634,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 40861,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 32237,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 28240,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24756,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22272,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16835,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 14852,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12593,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8580,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6117,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5327,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5209,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2660,
      "timestamp": "2023-03-09T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 217547,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 160706,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 144433,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 127828,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 119144,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76775,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 62483,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 57793,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 54360,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49692,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 44058,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41003,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 32605,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 28444,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24819,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22429,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 16948,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15050,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12673,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8625,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6157,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5347,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5222,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2682,
      "timestamp": "2023-03-09T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 218533,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 161080,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 144960,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 129043,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 119601,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 76904,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 62787,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 58348,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 55083,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49727,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 44474,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41195,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 32848,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 28778,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24837,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22520,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17014,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15075,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12739,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8707,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6221,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5484,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5227,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2692,
      "timestamp": "2023-03-09T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 220547,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 163327,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 145747,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 130627,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 120098,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 77076,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 62931,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 58582,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 55793,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49791,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 44846,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41375,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 32970,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 29080,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24843,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22584,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17115,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15088,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12765,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8817,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6263,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5631,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5234,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2694,
      "timestamp": "2023-03-09T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 223052,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 163499,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 146571,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 132067,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 120709,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 77330,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 63282,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 58872,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 56138,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49850,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 45205,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41560,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33121,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 29345,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24847,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22603,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17277,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15127,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12785,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8876,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6284,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5663,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5236,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2724,
      "timestamp": "2023-03-09T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 224731,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 165325,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 147779,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 133770,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 121382,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 77696,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 63475,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 59327,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 56856,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49940,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 45497,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41698,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33219,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 29580,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24871,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22619,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17349,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15250,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 12908,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 8982,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6300,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5743,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5241,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2765,
      "timestamp": "2023-03-09T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 226420,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 167407,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 149328,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 135336,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 122220,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 78173,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 63744,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 59886,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 57747,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 49987,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 46024,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41804,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33293,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 29876,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24945,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22660,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17448,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15275,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13036,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9066,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6323,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5763,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5247,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2770,
      "timestamp": "2023-03-09T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 228764,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168068,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 150727,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 136760,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 122694,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 78677,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64074,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 60544,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 58261,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50027,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 46531,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 41930,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33311,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30426,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 24981,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22664,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17524,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15318,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13049,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9083,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6350,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5862,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T22:00:00-05:00",
      "votes": 5247
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2774,
      "timestamp": "2023-03-09T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 229607,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168208,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 152018,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 137849,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123133,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79026,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64242,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 60981,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 58689,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50036,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 46914,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42031,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33441,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30619,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25005,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22710,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17566,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15340,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13053,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9125,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6373,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 5956,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5254,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T23:00:00-05:00",
      "votes": 2774
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 230742,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168258,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 152465,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 138317,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123470,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79099,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64318,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61100,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59203,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50048,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47212,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42062,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33458,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30702,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25061,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22789,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17574,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15372,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13054,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9166,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6375,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6041,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T00:00:00-05:00",
      "votes": 5254
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2779,
      "timestamp": "2023-03-10T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 231328,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168316,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 152705,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 138575,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123686,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79274,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64347,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61157,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59262,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50161,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47339,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42063,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33467,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30715,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25062,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T01:00:00-05:00",
      "votes": 22789
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17598,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15401,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T01:00:00-05:00",
      "votes": 13054
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T01:00:00-05:00",
      "votes": 9166
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6376,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6070,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T01:00:00-05:00",
      "votes": 5254
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2783,
      "timestamp": "2023-03-10T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 231330,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168444,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 153074,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 139006,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123794,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79381,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64375,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61201,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59403,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50166,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47382,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42065,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33474,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30750,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T02:00:00-05:00",
      "votes": 25062
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22808,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17642,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15433,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13055,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9167,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6378,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6121,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5255,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2786,
      "timestamp": "2023-03-10T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 231331,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168671,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 153243,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 139046,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123835,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79438,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64454,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61216,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59441,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50167,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47448,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T03:00:00-05:00",
      "votes": 42065
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33476,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30766,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T03:00:00-05:00",
      "votes": 25062
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22810,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17710,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15437,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13069,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9171,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6380,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6149,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T03:00:00-05:00",
      "votes": 5255
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T03:00:00-05:00",
      "votes": 2786
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T04:00:00-05:00",
      "votes": 231331
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 168724,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 153587,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 139202,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 123908,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79490,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64472,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61248,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59463,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50171,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47469,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42119,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33486,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30771,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25063,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22812,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17712,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15438,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13070,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9174,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6382,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6181,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T04:00:00-05:00",
      "votes": 5255
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2787,
      "timestamp": "2023-03-10T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T05:00:00-05:00",
      "votes": 231331
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 170967,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 153751,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 139610,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 124174,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79578,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64585,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61313,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59583,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50185,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47536,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42174,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33493,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30782,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25065,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22813,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17717,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15440,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13074,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9185,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6385,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6204,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T05:00:00-05:00",
      "votes": 5255
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T05:00:00-05:00",
      "votes": 2787
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 231361,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 171633,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 154026,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 140487,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 124328,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 79809,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64677,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61421,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59652,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50217,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47711,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42409,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33501,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30843,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25071,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22815,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17727,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15480,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13077,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9195,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6414,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6333,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T06:00:00-05:00",
      "votes": 5255
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2788,
      "timestamp": "2023-03-10T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 231546,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 172144,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 154494,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 141190,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 124466,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 80056,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64765,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61521,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 59864,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50576,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 47980,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42618,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33540,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 30992,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25083,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22827,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17749,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15642,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13104,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9198,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6456,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6424,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T07:00:00-05:00",
      "votes": 5255
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2802,
      "timestamp": "2023-03-10T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 233230,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 172293,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 155881,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 142137,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 124734,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 80190,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 64925,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 61753,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 60789,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50591,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 48193,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42767,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33636,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31142,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25091,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22835,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17803,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15680,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13247,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9328,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6589,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6442,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5257,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2822,
      "timestamp": "2023-03-10T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 234352,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 173754,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 156869,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 142935,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 125189,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 80377,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 65310,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 62116,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 61542,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50619,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 48633,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 42944,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 33856,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31192,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25113,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22878,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17876,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15707,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13383,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9354,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6718,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6677,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5259,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2826,
      "timestamp": "2023-03-10T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 237471,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 175033,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 157529,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 143770,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 125528,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 80506,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 65463,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 62558,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 62444,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50735,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 49304,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 43474,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34139,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31288,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25121,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 22997,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 17926,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15737,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13482,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9366,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 6872,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6824,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5277,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2865,
      "timestamp": "2023-03-10T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 237596,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 175249,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 158168,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 145387,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 126088,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 80821,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 65710,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 63541,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 63049,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50798,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 50257,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 43606,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34171,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31456,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25228,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23048,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18031,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15836,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13568,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9372,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7063,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6883,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5387,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2868,
      "timestamp": "2023-03-10T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 237951,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 175467,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 158809,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 146545,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 126499,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 81186,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 65914,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 64081,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 63387,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 51495,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50814,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 43843,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34284,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31517,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25295,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23171,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18068,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15861,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13597,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9466,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7133,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6892,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5390,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2876,
      "timestamp": "2023-03-10T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 240729,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 175825,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 160059,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 147394,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 126773,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 81455,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 66095,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 64867,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 63554,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 52435,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 50897,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44100,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34428,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31564,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25342,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23223,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18126,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15874,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13637,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9541,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7195,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6903,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5396,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2883,
      "timestamp": "2023-03-10T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 242578,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 176261,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 160720,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 148077,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 127143,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 81663,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 66275,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 65579,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 63906,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 52974,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51175,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44127,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34531,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31620,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25404,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23259,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18188,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 15925,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13774,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9547,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7258,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6951,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5399,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2889,
      "timestamp": "2023-03-10T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 243325,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 178118,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 161372,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 149062,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 127646,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 81936,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 66503,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 66446,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 64269,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 53404,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51265,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44240,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34568,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31732,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25440,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23312,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18239,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16085,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13809,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9555,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7315,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 6959,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5429,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2895,
      "timestamp": "2023-03-10T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 243552,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 180121,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 162558,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 150267,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 128147,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 82202,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 67435,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 66903,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 64491,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 54156,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51330,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44272,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34617,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 31826,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25449,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23344,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18268,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16231,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13889,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9630,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7451,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7058,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5435,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2904,
      "timestamp": "2023-03-10T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 245095,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 180421,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 163213,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 151740,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 128673,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 82367,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 68616,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 67838,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 64756,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 54614,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51394,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44373,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34747,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32005,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25472,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23393,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18380,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16254,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 13955,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9727,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7512,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7065,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5438,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2906,
      "timestamp": "2023-03-10T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 245996,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 180765,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 163754,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 152944,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 129067,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 82731,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 69517,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 69009,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 65147,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 55017,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51425,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44415,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 34914,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32041,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25539,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23414,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18456,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16269,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14036,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 9891,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7596,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7073,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5455,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2907,
      "timestamp": "2023-03-10T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 247151,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 181100,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 164630,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 154121,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 129821,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 82829,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 70805,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 70212,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 65471,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 55295,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51460,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44465,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35025,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32253,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25551,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23428,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18513,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16297,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14057,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10065,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7629,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7097,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5469,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2911,
      "timestamp": "2023-03-10T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 247379,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 181351,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 165565,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 155769,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 130432,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 83118,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 72147,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 70757,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 65870,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 55798,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51469,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44634,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35042,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32449,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25554,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23460,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18577,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16315,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14090,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10250,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7799,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7109,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5481,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2918,
      "timestamp": "2023-03-10T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 248000,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 181722,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 166588,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 157317,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 131161,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 83614,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 73222,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71306,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 66597,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 56407,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51488,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44829,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35084,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32754,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25560,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23502,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18640,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16332,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14103,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10355,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7929,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7135,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5510,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2929,
      "timestamp": "2023-03-10T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 249301,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 184756,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 167783,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 158330,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 131523,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 83782,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 73994,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71573,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 66898,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 57119,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 51603,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 44915,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35172,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 32953,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25572,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23515,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18689,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16342,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14127,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10373,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 7993,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7138,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5518,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2953,
      "timestamp": "2023-03-10T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 249522,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185515,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 168491,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 159048,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 131859,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84068,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 75177,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71651,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67392,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 57742,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52614,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45012,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35274,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33055,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25575,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23552,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18743,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16362,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14157,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10435,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8046,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7174,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5535,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2970,
      "timestamp": "2023-03-10T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 250857,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185540,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 169368,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 159452,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132143,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84284,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 75358,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71831,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67539,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 57958,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52754,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45022,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35288,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33069,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25577,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23559,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18778,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16414,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14200,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10451,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8201,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-11T00:00:00-05:00",
      "votes": 7174
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5544,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2977,
      "timestamp": "2023-03-11T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252099,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185632,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 169680,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 160248,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132260,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84372,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76010,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71868,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67593,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58052,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52837,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45184,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35308,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33098,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25578,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23564,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18786,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16461,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14201,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10452,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8269,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7178,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5546,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2978,
      "timestamp": "2023-03-11T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252121,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185670,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 170594,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 160567,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132302,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84413,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76198,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71882,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67631,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58122,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52842,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45254,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35310,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33159,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T02:00:00-05:00",
      "votes": 25578
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23567,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18809,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16483,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14204,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10454,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8336,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-11T02:00:00-05:00",
      "votes": 7178
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T02:00:00-05:00",
      "votes": 5546
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2980,
      "timestamp": "2023-03-11T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252122,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185697,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 170937,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 160951,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132376,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84469,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76253,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71924,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67664,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58269,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52850,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45261,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35312,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T03:00:00-05:00",
      "votes": 33159
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25580,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23571,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18859,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16518,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14206,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10455,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8400,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7181,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5548,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T03:00:00-05:00",
      "votes": 2980
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252123,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 185741,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 171088,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 161251,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132410,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84628,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76417,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71942,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67692,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58278,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52865,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45267,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35354,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 33159
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 25580
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23572,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18905,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16520,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14208,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10456,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8468,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7183,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 5548
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2982,
      "timestamp": "2023-03-11T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252130,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 188094,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 171162,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 161353,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132528,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84745,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76442,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 71952,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67713,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58469,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52868,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45341,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35355,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33165,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 25580
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23573,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 18908,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16586,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14210,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10457,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8473,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 7183
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 5548
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 2982
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252201,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 189219,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 171257,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 161867,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 132754,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84805,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76518,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 72271,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 67855,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58520,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 52969,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45447,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35370,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33167,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25588,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23576,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19002,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16607,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14215,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10511,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8491,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7186,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5550,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2983,
      "timestamp": "2023-03-11T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252315,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 189349,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 171586,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 162920,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 133197,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 84916,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 76991,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 72631,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 68000,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 58694,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53022,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45545,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35485,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33251,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T07:00:00-05:00",
      "votes": 25588
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23584,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19026,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16619,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14227,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10517,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8529,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7193,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5552,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 2999,
      "timestamp": "2023-03-11T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252704,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 189670,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 172352,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 163875,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 133680,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 85254,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 78096,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 72737,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 68364,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 59093,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53076,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45756,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35509,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33387,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25599,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23608,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19067,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16635,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14262,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10623,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8619,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7195,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5559,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3045,
      "timestamp": "2023-03-11T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 252877,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 192199,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 172597,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 164959,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 133881,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 85589,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 78726,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 72993,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 68698,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 59560,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53274,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 45844,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35570,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33456,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25694,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23619,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19123,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16651,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14269,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10729,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8663,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7214,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5568,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3115,
      "timestamp": "2023-03-11T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 254114,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 193716,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 173400,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 165708,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 134280,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 85957,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 79575,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73078,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 69132,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 59824,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53435,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 46043,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35616,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33635,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25696,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23628,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19178,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16676,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14305,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10752,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 8704,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7219,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5571,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3165,
      "timestamp": "2023-03-11T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 257255,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 194038,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 173815,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 166989,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 134727,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 86285,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 80370,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73137,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 69471,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 60482,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53512,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 46412,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35729,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33890,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25762,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23634,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19207,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16690,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14331,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 10909,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9074,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7236,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5577,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3170,
      "timestamp": "2023-03-11T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 257804,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 194250,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 175287,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 168204,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 135173,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 86553,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 81114,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73169,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 69691,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 60802,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53574,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 46640,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35804,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 33960,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25772,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23640,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19352,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16720,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14353,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11005,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9151,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7264,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5582,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3212,
      "timestamp": "2023-03-11T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 258014,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 194352,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 176319,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 169139,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 135893,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 86764,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 81956,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73236,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 70035,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 61310,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53650,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 46775,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35849,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34153,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25786,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23657,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19543,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16729,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14382,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11025,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9210,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7279,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5585,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3225,
      "timestamp": "2023-03-11T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 259808,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 197598,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 176851,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 170050,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 136425,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 87085,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 82359,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73297,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 70335,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 61551,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53701,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 46924,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 35964,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34366,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25796,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23668,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19594,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16738,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14417,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11051,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9271,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7310,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5587,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3336,
      "timestamp": "2023-03-11T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 262801,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 197771,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 177943,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 171313,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 136706,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 87307,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 83337,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73416,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 70801,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 61924,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53719,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47054,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36026,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34455,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25802,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23689,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19699,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16752,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14452,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11085,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9301,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7321,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5682,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3359,
      "timestamp": "2023-03-11T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 263466,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 198045,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 178815,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 172274,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 137187,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 87604,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 84642,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73600,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 71347,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 62221,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53742,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47212,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36064,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34566,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25819,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23699,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19781,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16771,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14511,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11251,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9400,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7347,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5685,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3454,
      "timestamp": "2023-03-11T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 264263,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 199247,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 179770,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 173212,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 137577,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 88120,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 85702,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73884,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 71939,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 62603,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53765,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47376,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36087,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34812,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25826,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23721,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19848,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16803,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14548,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11371,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9460,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7379,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5695,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3484,
      "timestamp": "2023-03-11T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 266308,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 201925,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 180363,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 174265,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 137843,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 88523,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 86303,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 73972,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 72566,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 63140,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53795,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47411,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36125,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 34950,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25884,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23756,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 19914,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16820,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14660,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11475,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9528,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7387,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5715,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3508,
      "timestamp": "2023-03-11T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 268130,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 202624,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 180946,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 176267,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 138271,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 89103,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 87154,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74054,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 73056,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 63506,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53891,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47474,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36162,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35220,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25887,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23851,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20116,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16830,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14717,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11636,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9617,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7395,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5736,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3536,
      "timestamp": "2023-03-11T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 269001,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 203047,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 182498,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 177845,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 138860,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 89572,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 88196,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74254,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 73677,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 64246,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53921,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47554,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36382,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35365,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25904,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 23996,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20248,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 16860,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14794,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11710,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9643,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7411,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5743,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3568,
      "timestamp": "2023-03-11T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 270144,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 204228,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 183739,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 179108,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 139468,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 90238,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 90137,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 74590,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74362,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 64924,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53941,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47609,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36524,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35473,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25922,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24067,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20455,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17021,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14833,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11732,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9691,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7421,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5746,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3749,
      "timestamp": "2023-03-11T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 272389,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207236,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 184891,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 180336,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 140381,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 92130,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 90601,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 75384,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74635,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 65493,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53963,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47665,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36782,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35604,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25971,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24081,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20557,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17122,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14872,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11821,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9754,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7425,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5747,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3868,
      "timestamp": "2023-03-11T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 273425,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207464,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 185747,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 182008,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 140964,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 93070,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91016,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 75805,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74712,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 65928,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 53977,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47700,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36848,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35687,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25974,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24096,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20585,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17201,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14879,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11874,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9801,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7451,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T23:00:00-05:00",
      "votes": 5747
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3892,
      "timestamp": "2023-03-11T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274098,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207571,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 186352,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 182787,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141397,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 93818,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91387,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76107,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74816,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66274,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54004,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47743,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36875,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35717,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25977,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24100,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20648,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17210,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14881,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11882,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9835,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7486,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5749,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 3978,
      "timestamp": "2023-03-12T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274136,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207795,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 186482,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 183391,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141632,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 94554,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91659,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76162,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74820,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66458,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54014,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47771,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36882,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35767,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25978,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24101,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20671,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17214,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14892,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11903,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9865,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7487,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T01:00:00-05:00",
      "votes": 5749
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4047,
      "timestamp": "2023-03-12T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274158,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207818,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 186719,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 183696,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141757,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 94768,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91758,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76169,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74836,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66518,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54015,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 47771
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36888,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 35767
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25982,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24102,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20707,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 17214
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14894,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11928,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9892,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 7487
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 5749
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4067,
      "timestamp": "2023-03-12T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274181,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 207860,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 187119,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 183952,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141813,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 94940,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91820,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76173,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74838,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66580,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54018,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47814,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36890,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35768,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 25982
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 24102
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 20707
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17215,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 14894
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 11928
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 9918,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7508,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 5749
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4088,
      "timestamp": "2023-03-12T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 274181
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 211308,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 187168,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 184343,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141878,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 94975,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 91912,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76238,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74851,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66742,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54020,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47815,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 36890
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 35768
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 25982
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 24102
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20713,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17216,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14899,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11934,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10091,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 7508
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 5749
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4090,
      "timestamp": "2023-03-12T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 274181
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 211319,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 187277,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 185212,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 141930,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 95033,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 92080,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76447,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74862,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66745,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54022,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47817,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36892,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35772,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 25982
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24106,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20715,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 17216
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 14899
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 11956,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10205,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7610,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5750,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4093,
      "timestamp": "2023-03-12T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274182,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 211473,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 187358,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 186200,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 142174,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 95102,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 92206,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76622,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 74943,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 66944,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54028,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47820,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36893,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35856,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25984,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24108,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20722,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17230,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14944,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12002,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10233,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7613,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5752,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4095,
      "timestamp": "2023-03-12T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274208,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 211741,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 187916,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 187582,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 142557,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 95401,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 92274,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 76792,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75037,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 67082,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54041,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47868,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 36937,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 35947,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25986,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24113,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20736,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17245,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 14953,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12008,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10274,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7663,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5755,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4118,
      "timestamp": "2023-03-12T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 274468,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 212072,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 190387,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 188395,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 142875,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 95979,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 92699,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 77122,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75262,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 67241,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54048,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 47923,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37097,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36165,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 25993,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24129,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20765,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17254,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15062,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12072,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10297,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7769,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5757,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4178,
      "timestamp": "2023-03-12T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 275926,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 214468,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 192901,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 188948,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 143144,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 96744,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 92976,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 77303,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75398,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 67523,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54059,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48087,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37156,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36264,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26052,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24132,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20838,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17269,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15073,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12172,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10309,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7777,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5761,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4203,
      "timestamp": "2023-03-12T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 277139,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 215226,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 195391,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 189318,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 143382,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 97866,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 93240,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 77548,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75483,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 67779,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54070,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48186,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37165,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36314,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26062,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24136,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20862,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17311,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15074,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12225,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10324,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7782,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5764,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4207,
      "timestamp": "2023-03-12T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 279136,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 215572,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 198242,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 190447,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 143626,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 98840,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 93311,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 77881,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75628,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 68027,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54107,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48241,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37199,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36414,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26096,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24151,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 20882,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17330,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15081,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12264,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10375,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7793,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5794,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4212,
      "timestamp": "2023-03-12T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 280423,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 215870,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 201685,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 191322,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 144010,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 99850,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 93385,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 78220,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75751,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 68354,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54123,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48323,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37248,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36512,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26100,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24173,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21086,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17357,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15089,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12374,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10449,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7821,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5803,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4265,
      "timestamp": "2023-03-12T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 281047,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 216057,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 203638,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 192427,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 144273,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 101131,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 93670,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 78535,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 75927,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 68673,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54147,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48439,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37283,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 36645,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26115,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24180,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21146,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17390,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15105,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12457,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10555,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7824,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5807,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4292,
      "timestamp": "2023-03-12T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 281965,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 218218,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 205132,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 193063,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 144649,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 102536,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 93976,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 78877,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 76222,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 69101,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54170,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48565,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37311,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 37279,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26120,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24191,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21311,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17412,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15111,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12510,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10657,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7835,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5808,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4298,
      "timestamp": "2023-03-12T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 283669,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 219555,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 206926,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 194348,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 145129,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 103295,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 94229,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 79129,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 76469,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 69475,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54189,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48668,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 37598,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37464,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26124,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24222,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21491,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17459,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15268,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12559,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10761,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7846,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 5814,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4309,
      "timestamp": "2023-03-12T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 285311,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 219691,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 208283,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 195427,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 145827,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 104227,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 94707,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 79552,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 76798,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 70160,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54274,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48748,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 37832,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37485,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26136,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24321,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21621,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17467,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15336,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12591,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 10852,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7857,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6021,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4320,
      "timestamp": "2023-03-12T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 286145,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 220431,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 209768,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 196232,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 146401,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 105055,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 95167,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 79986,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 77093,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 70479,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54288,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 48854,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 38278,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37508,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26140,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24356,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 21884,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17506,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15464,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12668,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11066,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7867,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6038,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4403,
      "timestamp": "2023-03-12T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 287279,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 222982,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 211356,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 197512,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 147248,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 105863,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 95418,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 80332,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 77157,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 71028,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54412,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49106,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 38433,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37515,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26204,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24375,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22015,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17520,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15635,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 12962,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11199,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7888,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6066,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4570,
      "timestamp": "2023-03-12T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 289052,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 224032,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 212987,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 199233,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 148097,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 106828,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 95764,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 80741,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 77481,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 71404,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54422,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49170,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 38657,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37529,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26211,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24395,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22169,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17536,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15643,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13047,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11354,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7937,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6072,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4592,
      "timestamp": "2023-03-12T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 290387,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 224427,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 214827,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 200935,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 148790,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 108593,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 96240,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81036,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 77622,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 72009,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 54630,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49303,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 38822,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37556,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26214,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24439,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22361,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17578,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15658,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13058,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11409,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7948,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6074,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4602,
      "timestamp": "2023-03-12T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 292017,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 226230,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 217804,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 203071,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 149517,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 109509,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 96594,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81222,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78119,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 72301,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55108,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49363,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39183,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37600,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26262,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24470,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22458,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17601,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15667,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13100,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11496,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 7956,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6082,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4637,
      "timestamp": "2023-03-12T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 293819,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 227990,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 220233,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 204493,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 150625,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 110699,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97029,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81454,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78220,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 72651,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55175,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49444,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39444,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37622,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26298,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24518,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22543,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17622,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15758,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13247,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11559,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8001,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6099,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4694,
      "timestamp": "2023-03-12T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 294136,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 228070,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 220926,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 205874,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 150887,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 111386,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97172,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81682,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78478,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73067,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55187,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49544,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39482,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37650,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26299,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24573,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22731,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17670,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15796,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13434,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11592,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8005,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6108,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4704,
      "timestamp": "2023-03-13T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 294137,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 228229,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 221775,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 206747,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151000,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112043,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97244,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81763,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78490,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73203,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55224,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49590,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39526,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37663,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26301,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24577,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22777,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17674,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 15796
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13475,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11627,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8008,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 4704
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 294139,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 228366,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 222041,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 207119,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151026,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112068,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97295,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81775,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78502,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73224,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55235,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49599,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39532,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37664,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26303,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24578,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22838,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17675,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T02:00:00-04:00",
      "votes": 15796
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13564,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11629,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-13T02:00:00-04:00",
      "votes": 8008
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T02:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4705,
      "timestamp": "2023-03-13T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 294140,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 229995,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 222693,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 207204,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151108,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112133,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97459,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81803,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78611,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73241,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55236,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49701,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39610,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37666,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 26303
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 24578
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22902,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17676,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 15796
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13566,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11652,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 8008
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4707,
      "timestamp": "2023-03-13T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 294140
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 232041,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 223148,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 207277,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151193,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112374,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97499,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81828,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78613,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73324,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55237,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49740,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39614,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 37666
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 26303
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24580,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22905,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17677,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15798,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13597,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11669,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 8008
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 4707
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 294140
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 232061,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 223458,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 207792,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151298,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112598,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97503,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81848,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78859,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73463,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55239,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49833,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39627,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 37666
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26310,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 24580
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22917,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17678,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15799,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13626,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11680,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8009,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 4707
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 294140
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 232281,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 224885,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 208748,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151386,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 112946,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 97808,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 81987,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 78992,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73533,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55243,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49840,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39690,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 37666
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 26310
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24587,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22918,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17682,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15881,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13630,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11711,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8010,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 6108
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4708,
      "timestamp": "2023-03-13T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 294141,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 232411,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 225707,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 209234,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151527,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 113140,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 98062,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 82182,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 79182,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 73726,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55261,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 49905,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 39783,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37671,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26312,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24596,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 22930,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17685,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15887,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13632,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11798,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8014,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6110,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4727,
      "timestamp": "2023-03-13T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 295225,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 233540,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 226813,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 210602,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 151862,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 113327,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 98268,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 82293,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 79257,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 74175,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55354,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50055,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 40021,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37687,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26315,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24611,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23003,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17746,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 15957,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13721,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11867,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8081,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6168,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4754,
      "timestamp": "2023-03-13T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 298155,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 234431,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 228319,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 211396,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 152220,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 113575,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 98632,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 82491,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 79519,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 74378,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55373,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50158,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 40327,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37694,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26318,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24681,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23069,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17768,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16108,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 13882,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 11997,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8103,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6169,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4758,
      "timestamp": "2023-03-13T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 298377,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 235044,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 230280,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 212629,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 152714,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 114214,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 98928,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 82803,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 80123,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 74708,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55409,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50259,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 40576,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37705,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26321,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24765,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23218,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17819,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16235,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14030,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12114,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8153,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6174,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4818,
      "timestamp": "2023-03-13T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 299221,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 236892,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 232568,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 214065,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 153310,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 114728,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 99300,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 83156,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 80648,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 75000,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55426,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50390,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 40919,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37730,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26331,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24862,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23364,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17857,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16269,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14199,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12210,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8219,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6177,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4847,
      "timestamp": "2023-03-13T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 299736,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 238167,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 235499,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 216062,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 153817,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 115204,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 99742,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 83430,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 80838,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 75288,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55444,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50588,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 41165,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37786,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26334,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24888,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23527,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17910,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16342,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14482,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12249,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8327,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6181,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4877,
      "timestamp": "2023-03-13T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 302194,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 238688,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 237507,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 217107,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 154207,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 115933,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 100227,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 83685,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 81202,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 75501,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55560,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50708,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 41530,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37824,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26375,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24902,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23699,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 17953,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16349,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14604,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12307,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8360,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6212,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4888,
      "timestamp": "2023-03-13T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 303491,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 241605,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 239809,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 218198,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 154745,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 116237,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 100761,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 84099,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 81688,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 76220,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55724,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 50905,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 41670,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37895,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26393,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 24964,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23821,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18003,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16381,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14700,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12365,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8413,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6226,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4896,
      "timestamp": "2023-03-13T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 304604,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 244570,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 241064,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 219567,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 155535,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 117295,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 101598,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 84388,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 82261,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 77317,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55772,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51054,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 41887,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 37986,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26455,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25050,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 23915,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18092,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16387,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 14856,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12441,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8506,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6229,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4935,
      "timestamp": "2023-03-13T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 306571,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 249774,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 243253,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 220728,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 156211,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 118095,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 102414,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 84681,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 82922,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 78624,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 55838,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51267,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 42179,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38049,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26529,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25079,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24025,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18125,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16529,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15028,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12493,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8547,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6261,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 4975,
      "timestamp": "2023-03-13T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 309141,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 252872,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 244064,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 221328,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 156810,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 118722,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 103170,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 85050,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 83421,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 79276,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 56268,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51471,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 42487,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38136,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26538,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25153,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24092,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18161,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16787,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15092,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12661,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8573,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6307,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5070,
      "timestamp": "2023-03-13T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 311045,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 255544,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 245377,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 223047,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 157652,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 119979,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 103646,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 85684,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 83889,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 79830,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 56442,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51574,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 42644,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38194,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26591,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25277,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24212,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18185,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16826,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15270,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12824,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8590,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6474,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5087,
      "timestamp": "2023-03-13T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 313559,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 258557,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 246084,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 225102,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 158718,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 120684,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 104139,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 86065,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 85006,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 80391,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 56691,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51679,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 42957,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38220,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26638,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25322,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24380,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18204,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 16882,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15416,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 12935,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8597,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6486,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5165,
      "timestamp": "2023-03-13T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 315460,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 261649,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 247911,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 227451,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 160121,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 122174,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 104595,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 86778,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 86733,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 80896,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 56969,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 51770,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 43410,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38341,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26645,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25341,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24461,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18290,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17073,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15520,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 13098,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8607,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6493,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5281,
      "timestamp": "2023-03-13T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 316252,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 264707,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 250444,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 230556,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 161499,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 123844,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 105000,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 88242,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 87839,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 82142,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 57133,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52235,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 43716,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38363,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26663,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25403,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24568,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18324,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17248,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15634,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 13331,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8632,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6525,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5290,
      "timestamp": "2023-03-13T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 321487,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 268251,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 251268,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 232566,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 162428,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 124813,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 105452,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 89531,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88278,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 84368,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 57763,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52406,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44237,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38378,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26680,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25441,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24665,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18361,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17290,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 15756,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 13548,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8674,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6535,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5301,
      "timestamp": "2023-03-13T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 324793,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 270614,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 251785,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 234012,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163070,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 125793,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 105990,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 90271,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88429,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 85583,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 57846,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52435,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44443,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38427,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26700,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25529,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 24886,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18382,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17348,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16023,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 13680,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8681,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6545,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5362,
      "timestamp": "2023-03-13T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 327748,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 271720,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 254432,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 235059,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163350,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 126273,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 106392,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 90482,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88622,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 86269,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 57858,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52689,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44610,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38444,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26741,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25536,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25034,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18395,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17454,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16213,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 13945,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8689,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6553,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5365,
      "timestamp": "2023-03-14T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 329181,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 272722,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 255771,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 235560,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163478,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 126655,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 106555,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 90620,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88667,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 86623,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58030,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52753,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44672,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38449,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T01:00:00-04:00",
      "votes": 26741
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25539,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25121,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18419,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17464,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16238,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14042,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8696,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6556,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5373,
      "timestamp": "2023-03-14T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 332093,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 272908,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 255941,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 235898,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163582,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 126684,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 106700,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 90878,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88736,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 86855,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58032,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52819,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44703,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38475,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26743,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25541,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25170,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18428,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T02:00:00-04:00",
      "votes": 17464
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16305,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14053,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-14T02:00:00-04:00",
      "votes": 8696
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6557,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T02:00:00-04:00",
      "votes": 5373
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 333434,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 273282,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 256121,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 236238,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163802,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 126979,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 106924,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 91271,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88770,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 86944,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58046,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 52970,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44770,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38510,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T03:00:00-04:00",
      "votes": 26743
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T03:00:00-04:00",
      "votes": 25541
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25217,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18432,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17513,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16320,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14074,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8697,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6559,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5374,
      "timestamp": "2023-03-14T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 334402,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 273821,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 256305,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 236830,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163828,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 127541,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 107014,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 91428,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 88782,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 87120,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58051,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 53063,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44772,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38562,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26747,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25542,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25221,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18434,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17530,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16332,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14103,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8699,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T04:00:00-04:00",
      "votes": 6559
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5375,
      "timestamp": "2023-03-14T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 334670,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 274333,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 256437,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 237537,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 163857,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 127639,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 107139,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 91536,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 89023,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 87423,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58060,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 53125,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44793,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38563,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T05:00:00-04:00",
      "votes": 26747
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25543,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25246,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18437,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17538,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16404,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14185,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8700,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T05:00:00-04:00",
      "votes": 6559
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T05:00:00-04:00",
      "votes": 5375
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 334792,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 274817,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 259460,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 238346,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 164112,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 127782,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 107283,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 91675,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 89270,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 87740,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58064,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 53483,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44873,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38579,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26757,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25553,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25424,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18453,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17543,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16427,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14266,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8705,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6661,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5376,
      "timestamp": "2023-03-14T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 335542,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 275747,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 259762,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 239330,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 164277,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 127882,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 107680,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 91983,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 89669,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 88029,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58081,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 53583,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 44965,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38582,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26760,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25562,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25445,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18459,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17689,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16430,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14389,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8720,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6685,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5427,
      "timestamp": "2023-03-14T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 336415,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 277510,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 260365,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 240128,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 164622,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 128898,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 108026,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 92285,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 90280,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 88627,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58101,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 53620,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 45032,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38617,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26764,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25616,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25575,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18654,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17840,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16433,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14436,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8765,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6771,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5481,
      "timestamp": "2023-03-14T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 338954,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 279247,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 261310,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 240992,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 165235,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 129391,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 108349,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 92593,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 90766,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 89163,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58126,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54065,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 45182,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38653,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26801,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25809,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25626,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18691,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 17966,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16530,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14530,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8806,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6774,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5485,
      "timestamp": "2023-03-14T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 341556,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 280447,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 261903,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 242317,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 165925,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 130286,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 108655,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 92829,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 91342,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 89660,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58142,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54341,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 45588,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38685,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26803,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 25910,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25779,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18716,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18009,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16675,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14640,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8822,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6834,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5559,
      "timestamp": "2023-03-14T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 343017,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 281996,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 263741,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 243694,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 166404,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 131054,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 109144,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 93269,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 93158,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 90801,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58217,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54456,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 45965,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38817,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26814,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 26198,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25909,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18733,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18026,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16809,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14693,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8831,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6867,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5754,
      "timestamp": "2023-03-14T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 344110,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 283217,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 264122,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 245677,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 167048,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 132050,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 109608,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 94507,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 94260,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 91842,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58244,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54772,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46202,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38836,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26843,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 26305,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 25974,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18753,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18200,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16940,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14740,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8855,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6907,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5787,
      "timestamp": "2023-03-14T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 345497,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 285061,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 264840,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 246774,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 167470,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 132433,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 109915,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 95417,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 94940,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 92893,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58256,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54892,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46395,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38900,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26853,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 26502,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26038,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18769,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18303,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16981,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 14880,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8859,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6915,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5836,
      "timestamp": "2023-03-14T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 348735,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 286332,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 265283,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 247755,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 168078,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 133161,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 110387,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 96157,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 95373,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 93950,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58445,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 54979,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46603,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38919,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26878,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 26787,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26152,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18827,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18421,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 16989,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15005,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8874,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6924,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5875,
      "timestamp": "2023-03-14T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 350675,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 287324,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 265517,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 249679,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 168513,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 134607,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 110682,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 96572,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 95776,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 94703,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58535,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55139,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46734,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 38986,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27087,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26894,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26169,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18840,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18473,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17123,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15070,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8904,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6935,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5915,
      "timestamp": "2023-03-14T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 352192,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 288163,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 265827,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 250536,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 168853,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 135481,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 110930,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 96944,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 96067,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 95464,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58606,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55309,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46872,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39023,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27217,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26905,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26302,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18847,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18607,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17226,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15101,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8923,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6945,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5953,
      "timestamp": "2023-03-14T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 353290,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 289622,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 266144,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 253190,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 169152,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 135666,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 111173,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 97336,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 96212,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 96203,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 58843,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55582,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 46983,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39051,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27398,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T17:00:00-04:00",
      "votes": 26905
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26354,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18865,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18635,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17269,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15127,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8928,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 6965,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 5982,
      "timestamp": "2023-03-14T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 354210,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 290625,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 266512,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 254716,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 169529,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 135979,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 111485,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 97815,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 97081,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 96473,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59433,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55678,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47099,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39106,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27477,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26907,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26392,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18887,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18694,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17313,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15180,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8938,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7003,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6070,
      "timestamp": "2023-03-14T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 356723,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 291509,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 269010,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 256391,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 170145,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 136592,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 111919,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 98236,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 97955,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 96655,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59601,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55829,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47167,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39121,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27574,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26912,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26433,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18939,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18744,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17344,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15264,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8943,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7009,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6083,
      "timestamp": "2023-03-14T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 358428,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 292581,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 271111,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 257874,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 170521,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 137780,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 112211,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 99091,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 98679,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97071,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59662,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 55953,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47310,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39164,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27724,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26915,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26454,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18960,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18848,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17426,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15314,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8959,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7034,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6085,
      "timestamp": "2023-03-14T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 360611,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 294062,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 271529,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 259293,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 171168,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 138726,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 112691,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 99805,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 99385,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97679,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59691,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 56345,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47482,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39189,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27854,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26919,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26504,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 18986,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 18958,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17539,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15438,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8963,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7142,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6102,
      "timestamp": "2023-03-14T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 362463,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 295850,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273068,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 261070,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 171540,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 139712,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 113152,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 100778,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100264,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97734,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59753,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 56644,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47758,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39211,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 27940,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26932,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26582,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19099,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19011,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17619,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15524,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8967,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7258,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6109,
      "timestamp": "2023-03-14T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 363560,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 296654,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273595,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 261761,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172004,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140163,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 113633,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 101406,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100548,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97799,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59832,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 56870,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47881,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39219,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28017,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26934,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26585,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19127,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19015,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17666,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15570,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8974,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7273,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6145,
      "timestamp": "2023-03-14T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365155,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297139,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273849,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262601,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172182,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140500,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 113844,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 101886,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100665,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97875,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59845,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57029,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47887,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39243,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28101,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26954,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26587,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19142,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19022,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T00:00:00-04:00",
      "votes": 17666
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15681,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8975,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7274,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6148,
      "timestamp": "2023-03-15T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365157,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297231,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273903,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262718,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172253,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140557,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 113882,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102196,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100690,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 97983,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59847,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57071,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47889,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39258,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28170,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T01:00:00-04:00",
      "votes": 26954
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T01:00:00-04:00",
      "votes": 26587
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19144,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19029,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17667,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15719,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8976,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T01:00:00-04:00",
      "votes": 7274
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6149,
      "timestamp": "2023-03-15T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365164,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297286,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273918,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262784,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172285,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140607,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 113975,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102251,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100715,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98084,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59849,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57119,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 47890,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39270,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28175,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 26955,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 26587
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19145,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19042,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 17667
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15804,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 8976
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 7274
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 6149
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 365164
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297429,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 273993,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262804,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172302,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140647,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114027,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102264,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100788,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98151,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59851,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 57119
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48010,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39273,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28183,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27003,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26594,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19156,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19049,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17691,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15812,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8977,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7277,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6159,
      "timestamp": "2023-03-15T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365165,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297673,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 274045,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262820,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172342,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140654,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114078,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102388,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100894,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98208,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59853,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57142,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48011,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39274,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28188,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27007,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 26594
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19157,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 19049
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17706,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15815,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 8977
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 7277
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 6159
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365169,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297780,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 274084,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262882,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172453,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140685,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114135,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102585,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 100965,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98223,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59893,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57144,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48029,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39276,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28195,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 27007
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 26594
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19158,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19050,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 17706
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15824,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8978,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 7277
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 6159
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365171,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 297942,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 274214,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 262982,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172560,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140724,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114285,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 102809,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 101014,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98281,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59906,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57184,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48086,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39278,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28211,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 27007
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 26594
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19170,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19053,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17714,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15838,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8979,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 7277
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 6159
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365173,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 298304,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 274376,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 263044,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172669,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140844,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114508,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 103158,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 101124,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98388,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59918,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57228,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48141,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39297,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28228,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27011,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26599,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19178,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19090,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17735,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15856,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8981,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7278,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6203,
      "timestamp": "2023-03-15T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365200,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 298676,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 274688,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 263201,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 172832,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 140919,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114682,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 103400,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 101387,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98617,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59944,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57336,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48222,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39310,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28263,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27017,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26605,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19240,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19142,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17742,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15892,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 8984,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T08:00:00-04:00",
      "votes": 7278
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6219,
      "timestamp": "2023-03-15T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365230,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 299043,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 275060,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 263619,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 173129,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141116,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 114898,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 103669,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 101706,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98753,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59951,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57409,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48317,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39342,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28331,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27029,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26632,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19300,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19272,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17760,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 15944,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9006,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T09:00:00-04:00",
      "votes": 7278
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6222,
      "timestamp": "2023-03-15T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365301,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 300282,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 275324,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 263950,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 173384,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141289,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 115276,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 104108,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 101848,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 98970,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 59976,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57453,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48367,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39377,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28407,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27036,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26652,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19433,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19373,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17960,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16064,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9018,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7280,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6231,
      "timestamp": "2023-03-15T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365361,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 301225,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 275443,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 264294,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 173659,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141495,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 115594,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 104489,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 102040,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 99213,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60023,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57529,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48463,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39401,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28506,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27039,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26674,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19557,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19385,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 17975,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16162,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9025,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7284,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6236,
      "timestamp": "2023-03-15T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365409,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 302526,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 275669,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 264575,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 174073,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141597,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 116066,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 104945,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 102478,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 99381,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60042,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57578,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48555,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39430,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28572,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T12:00:00-04:00",
      "votes": 27039
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26726,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19594,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19392,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18028,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16179,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9052,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7380,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6238,
      "timestamp": "2023-03-15T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365447,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 303315,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 275932,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 264831,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 174415,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141701,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 116307,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 105366,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 102737,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 99680,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60057,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57624,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48675,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39451,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28656,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27045,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26741,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19639,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19400,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18091,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16212,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9064,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7398,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6246,
      "timestamp": "2023-03-15T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365511,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 304011,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 276313,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 265122,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 174662,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 141842,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 116549,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 106085,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 103065,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 100107,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60067,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57673,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48729,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39470,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28774,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27063,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26786,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19652,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19533,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18169,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16249,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9129,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7399,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6252,
      "timestamp": "2023-03-15T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365535,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 304831,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 276484,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 265380,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 175086,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 142069,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 116725,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 106721,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 103298,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 100492,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60117,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57708,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48786,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39491,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 28902,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27064,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26860,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19669,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19576,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18172,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16267,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9141,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7402,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6253,
      "timestamp": "2023-03-15T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365631,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 305609,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 276814,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 265720,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 175287,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 142242,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 116977,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 107162,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 103563,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 101159,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60140,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57747,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48854,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39505,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29007,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27080,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26914,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19789,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19627,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18196,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16312,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9162,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7403,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6254,
      "timestamp": "2023-03-15T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365708,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 306369,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 277073,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 266083,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 175454,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 142405,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 117322,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 107684,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 103846,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 101439,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60149,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57847,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48919,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39535,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29110,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27087,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26941,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19893,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19660,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18369,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16355,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9172,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7407,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6262,
      "timestamp": "2023-03-15T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365736,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 307267,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 277294,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 266347,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 175716,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 142729,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 118029,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 108018,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 103999,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 101665,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60172,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 57914,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 48957,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39537,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29158,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27098,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26944,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 19977,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19668,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18441,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16531,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9181,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7470,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6272,
      "timestamp": "2023-03-15T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365773,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 308020,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 277548,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 266589,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 176235,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 142921,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 118468,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 108451,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 104224,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102066,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60190,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58008,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49012,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39555,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29192,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27102,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 26959,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20013,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19684,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18505,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16557,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9194,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7472,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6273,
      "timestamp": "2023-03-15T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365787,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 308938,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 277778,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 266810,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 177045,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 143118,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 118625,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 108850,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 104455,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102337,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60201,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58105,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49102,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39582,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29251,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27104,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27058,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20086,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19696,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18557,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16627,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9206,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7473,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6276,
      "timestamp": "2023-03-15T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 365928,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 310080,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 277933,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 267269,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 177884,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 143420,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 118978,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 109319,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 104745,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102567,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60214,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58210,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49267,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39599,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29343,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27118,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27068,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20150,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19726,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18606,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16654,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9210,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7476,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6290,
      "timestamp": "2023-03-15T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366099,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 310962,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278076,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 267625,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 178312,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 143550,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 119399,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 109603,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105017,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102649,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60273,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58293,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49367,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39612,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29400,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27126,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27120,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20167,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19735,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18652,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16709,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9224,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7478,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6340,
      "timestamp": "2023-03-15T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366280,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 311690,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278298,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 267973,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 178623,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 143689,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 119596,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110105,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105322,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102697,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60312,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58329,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49464,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39627,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29441,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27153,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27128,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20180,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19747,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18743,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16732,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9228,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7479,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6344,
      "timestamp": "2023-03-15T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366453,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 312292,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278439,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 268517,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 178942,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 143856,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 119987,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110444,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105504,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102716,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60325,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58338,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49494,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39646,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29463,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27160,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27133,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20183,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19762,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18785,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16741,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T00:00:00-04:00",
      "votes": 9228
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7485,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6350,
      "timestamp": "2023-03-16T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366870,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 312612,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278449,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 269132,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179024,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144128,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120122,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110588,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105670,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102730,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60332,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58401,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49511,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 39646
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29482,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27162,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27155,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 20183
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19764,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 18785
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16754,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 9228
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7487,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366878,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 312704,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278452,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 269359,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179085,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144501,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120231,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110662,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105890,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102741,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60347,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 58401
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49525,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39650,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 29482
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27176,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27163,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20184,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 19764
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 18785
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16774,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9229,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7489,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366889,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 312757,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278481,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 269685,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179173,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144517,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120353,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110711,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 105964,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102776,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60348,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58425,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49527,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 39650
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29496,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27190,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27164,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20195,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19766,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18786,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16803,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 9229
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7490,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366890,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 312930,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278521,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 270459,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179209,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144548,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120363,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 110883,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106044,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102952,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60349,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58477,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49537,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39652,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29499,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27200,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 27164
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20198,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19768,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18830,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16804,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9231,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7492,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366893,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 313232,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278566,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 270801,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179227,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144675,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120384,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 111052,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106069,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 102963,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60355,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58482,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49559,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39655,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29502,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 27200
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27165,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20200,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19769,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 18967,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16810,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 9231
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7493,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 366908,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 314109,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 278927,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 271863,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179384,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 144702,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120455,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 111142,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106106,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103052,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60365,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58531,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49598,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39656,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29518,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27207,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27170,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20206,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19771,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19026,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16833,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9232,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T06:00:00-04:00",
      "votes": 7493
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T06:00:00-04:00",
      "votes": 6350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 367332,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 314920,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 279085,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 272129,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179539,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 145008,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120537,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 111358,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106176,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103157,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60382,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58599,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49627,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39663,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29538,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27233,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27176,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20239,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19777,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19041,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16890,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9238,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7496,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6351,
      "timestamp": "2023-03-16T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 369360,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 315676,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 279346,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 272734,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 179765,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 145499,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120728,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 111630,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106350,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103286,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60408,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58770,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49724,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39670,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29593,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27247,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27184,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20361,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19779,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19071,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16928,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9286,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7500,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6357,
      "timestamp": "2023-03-16T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 372968,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 317327,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 281792,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 273448,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 180029,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 146300,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 120989,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 111931,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106483,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103350,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60437,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58878,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49765,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39689,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29663,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27289,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27218,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20420,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19792,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19108,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16952,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9299,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7504,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6365,
      "timestamp": "2023-03-16T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 375570,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 318261,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 281893,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 274566,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 180387,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 147139,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 121395,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 112341,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106717,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103548,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60442,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 58940,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49805,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39737,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29758,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27303,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27292,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20441,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19834,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19123,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 16971,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9304,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7517,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6366,
      "timestamp": "2023-03-16T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 377326,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 319159,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 282158,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 275890,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 180715,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 147411,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 121760,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 112788,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 106855,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 103917,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60454,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 59146,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 49921,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39758,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29832,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27367,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T11:00:00-04:00",
      "votes": 27292
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20507,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19862,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19207,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17043,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9309,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7529,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6417,
      "timestamp": "2023-03-16T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 379064,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 319971,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 282485,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 276937,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 180943,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 148112,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 122166,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 113223,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 107085,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104091,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60458,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 59212,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50057,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39790,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29872,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27467,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27294,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20554,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19872,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19418,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17079,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9318,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7545,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6482,
      "timestamp": "2023-03-16T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 381853,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 320904,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 282681,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 278208,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 181180,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 148867,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 122370,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 113656,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 107370,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104251,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60479,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 59418,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50131,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39798,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29923,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27509,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27296,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20598,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19890,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19559,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17094,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9320,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7572,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6500,
      "timestamp": "2023-03-16T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 383780,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 321627,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 283442,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 279208,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 181387,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 149744,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 122709,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 114174,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 107506,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104432,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60508,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 59758,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50235,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39831,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 29981,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27537,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27314,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20622,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19900,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19644,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17112,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9326,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7573,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6502,
      "timestamp": "2023-03-16T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 385924,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 322415,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 283924,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 280386,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 181711,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 150318,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 122955,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 114728,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 107663,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104553,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60624,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 60306,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50296,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39837,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30100,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27610,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27318,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20637,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19909,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19653,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17155,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9331,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7578,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6513,
      "timestamp": "2023-03-16T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 387441,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 323223,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 284050,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 281677,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 182062,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 150970,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 123360,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 115566,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 107826,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104739,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60662,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 60411,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50342,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39866,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30218,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27672,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27331,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20669,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19917,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19662,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17169,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9334,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7587,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6525,
      "timestamp": "2023-03-16T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 388258,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 324028,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 284656,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 282627,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 182222,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 151715,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 123816,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 116097,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 108056,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104793,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 60839,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60671,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50482,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39879,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30313,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27683,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T17:00:00-04:00",
      "votes": 27331
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20674,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19932,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19778,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17201,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9346,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7595,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6528,
      "timestamp": "2023-03-16T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 389319,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 324651,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 285034,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 283958,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 182490,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 152729,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 124115,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 116416,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 108280,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 104888,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 61531,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60815,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50649,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39883,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30404,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27706,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27334,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20716,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19940,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19881,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17209,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9357,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7612,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6530,
      "timestamp": "2023-03-16T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 390443,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 325461,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 286303,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 286137,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 182875,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 153636,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 124421,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 116847,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 108483,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105026,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 62082,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60884,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50741,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39920,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30490,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27710,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27350,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20805,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 19987,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19962,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17230,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9361,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T19:00:00-04:00",
      "votes": 7612
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6534,
      "timestamp": "2023-03-16T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 391967,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 326534,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 288566,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 287477,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 183868,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 154324,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 124816,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 117210,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 108652,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105132,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 62484,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60912,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50812,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39923,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30598,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27721,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27374,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20826,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20062,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 19980,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17244,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9369,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7615,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6541,
      "timestamp": "2023-03-16T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 392865,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 328145,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 289406,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 288954,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 184485,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 156012,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125133,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 117462,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 109073,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105209,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 62756,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 60922,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50902,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39981,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30692,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27735,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27387,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20862,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20139,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20004,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17258,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9372,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7620,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6542,
      "timestamp": "2023-03-16T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 396981,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 329669,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 291621,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 289527,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 184788,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 156511,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125409,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 117643,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 109579,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105271,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 63355,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61076,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 50933,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 39998,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30750,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27747,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27398,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20926,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20202,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20056,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17291,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9402,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7633,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6544,
      "timestamp": "2023-03-16T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 399755,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331005,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 294051,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 292059,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 184973,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 157319,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125607,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 117850,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 109850,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105291,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 63883,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61153,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51018,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40003,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30802,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27759,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27406,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20940,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20210,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20062,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17323,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9414,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7639,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6546,
      "timestamp": "2023-03-16T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 400748,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331239,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 295160,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293038,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185175,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 158559,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125773,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118110,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110031,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105317,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64265,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61185,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51080,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40014,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30840,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27764,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27428,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20966,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20225,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20067,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17340,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-17T00:00:00-04:00",
      "votes": 9414
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7640,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6548,
      "timestamp": "2023-03-17T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 401537,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331575,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 295786,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293110,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185273,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 159394,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125905,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118220,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110090,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105323,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64285,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61241,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51082,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40021,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30866,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T01:00:00-04:00",
      "votes": 27764
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27432,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20972,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20230,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20082,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17368,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9421,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7641,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6550,
      "timestamp": "2023-03-17T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 401564,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331676,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 295884,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293191,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185297,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160177,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 125956,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118244,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110147,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105332,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64307,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61297,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51102,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40025,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30869,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 27764
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 27432
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20973,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20237,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20085,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17371,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9427,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 7641
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 6550
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 401566,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331720,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 296016,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293268,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185334,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160374,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126060,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118365,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110202,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105337,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64308,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61316,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51104,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 40025
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30872,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27765,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 27432
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20976,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 20237
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20086,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17428,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 9427
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7642,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 6550
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 401566
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 331961,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 296753,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293290,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185372,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160405,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126110,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118555,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110224,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105342,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64316,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61361,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 51104
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 40025
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30886,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 27765
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 27432
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 20976
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20247,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20089,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17456,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9428,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 7642
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6554,
      "timestamp": "2023-03-17T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 401566
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 332333,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 297502,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 293365,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185413,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 160405
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126132,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118752,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110326,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105389,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64490,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61406,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51105,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 40025
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30894,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27766,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27433,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20978,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20248,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20090,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17458,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9429,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 7642
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 6554
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 401567,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 332622,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 298275,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 296904,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185602,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160461,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126191,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118847,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110450,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105490,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64516,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61421,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51121,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40026,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30903,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27767,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T06:00:00-04:00",
      "votes": 27433
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 20990,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20268,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20093,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17475,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9431,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T06:00:00-04:00",
      "votes": 7642
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6555,
      "timestamp": "2023-03-17T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 401653,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 333411,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 298650,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 297038,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185708,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 160829,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126269,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 118958,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110591,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105562,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64702,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61443,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51145,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40032,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30941,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27775,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27435,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21051,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20281,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20095,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17495,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9436,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7643,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T07:00:00-04:00",
      "votes": 6555
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 402045,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 334215,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 299727,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 297134,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 185892,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 161078,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126459,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 119123,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110697,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105651,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 64817,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61496,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51167,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40054,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 30996,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27776,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27446,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21134,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20296,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20215,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17535,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9445,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7644,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6565,
      "timestamp": "2023-03-17T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 402377,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 335354,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 300822,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 297395,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 186142,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 161241,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126558,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 119237,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 110967,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105696,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 65029,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61666,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51244,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40064,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31062,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27782,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27450,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21180,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20381,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20230,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17584,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9450,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7647,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6606,
      "timestamp": "2023-03-17T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 404084,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 336608,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 301775,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 300924,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 186321,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 161484,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 126918,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 119559,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111079,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 105845,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 65797,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61693,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51299,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40100,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31101,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27818,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27469,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21221,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20497,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20243,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17635,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9453,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7649,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6726,
      "timestamp": "2023-03-17T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 406270,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 337362,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 303389,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 301522,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 186443,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 161902,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 127596,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 120131,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111194,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106024,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 66027,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61729,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51381,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40114,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31164,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27845,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27494,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21258,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20754,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20266,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17710,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9455,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7651,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6730,
      "timestamp": "2023-03-17T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 407103,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 338439,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 305065,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 301705,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 186775,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 162725,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 127808,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 120703,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111350,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106136,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 66190,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61757,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51426,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40152,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31207,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27858,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27509,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21329,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 20874,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 20658,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17801,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9463,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7654,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6737,
      "timestamp": "2023-03-17T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 407768,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 339504,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 306470,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 302118,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 187123,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 163484,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 127973,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 121437,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111609,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106218,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 66499,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61783,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51566,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40196,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31284,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27871,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27520,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21336,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21270,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21009,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17853,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9466,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7662,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6738,
      "timestamp": "2023-03-17T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 408255,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 340743,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 307817,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 302464,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 187352,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 164278,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 128122,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 121839,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111793,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106301,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 66903,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 61828,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51587,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40259,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31396,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27902,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27542,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21388,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21376,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21027,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17868,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9470,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7679,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6746,
      "timestamp": "2023-03-17T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 410847,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 341402,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 309620,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 304691,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 187535,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 164784,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 128470,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 122133,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 111957,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106494,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 67189,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62056,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51605,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40271,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31488,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27928,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27549,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21435,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21408,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21039,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17885,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9471,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7689,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6755,
      "timestamp": "2023-03-17T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 411138,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 342256,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 310716,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 306774,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 187696,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 165240,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 128900,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 122550,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 112076,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 106855,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 67374,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62064,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51654,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40292,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31526,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27939,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27555,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21484,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21432,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21050,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17893,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9473,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7698,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6758,
      "timestamp": "2023-03-17T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 413041,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 343438,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 312643,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 306950,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 188074,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 166625,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 129187,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 122900,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 112305,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107098,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 67490,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62468,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51789,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40354,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31627,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27949,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27559,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21508,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21459,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21143,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17910,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9479,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7702,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6759,
      "timestamp": "2023-03-17T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 414338,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 344298,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 314280,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 307231,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 188404,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 167364,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 129393,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 123265,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 112547,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107219,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 68298,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62484,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51875,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40359,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31727,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27957,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27565,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21519,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21467,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21249,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17941,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9482,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T18:00:00-04:00",
      "votes": 7702
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6762,
      "timestamp": "2023-03-17T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 414912,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 345140,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 315423,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 309842,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 188919,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 168614,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 129538,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 123513,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 112768,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107358,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 68421,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62556,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 51992,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40367,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31809,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27968,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27573,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21534,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21499,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21330,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 17944,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9487,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7704,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6767,
      "timestamp": "2023-03-17T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 417190,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 345894,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 317920,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 311232,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 189281,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 169267,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 129752,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 123684,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 112996,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107464,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 68590,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62571,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52173,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40395,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31885,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27975,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27578,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21638,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21573,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21435,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18047,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9492,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7705,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 6901,
      "timestamp": "2023-03-17T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 418261,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 347591,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 319369,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 311439,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 189604,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 170292,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 130123,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 124165,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113126,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107627,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 68839,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62624,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52315,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40400,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 31956,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27987,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T21:00:00-04:00",
      "votes": 27578
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21712,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21588,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21525,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18099,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9501,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7708,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7049,
      "timestamp": "2023-03-17T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 419283,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 348664,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 320656,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 311792,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190100,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 170946,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 130432,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 124468,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113285,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107785,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 69571,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62647,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52374,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40404,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32032,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 27990,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27579,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21758,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21633,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21618,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18124,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9502,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T22:00:00-04:00",
      "votes": 7708
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7102,
      "timestamp": "2023-03-17T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 419962,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 349364,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 322165,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315451,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190278,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 171808,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 130763,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 124819,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113486,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 107952,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70210,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62657,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52408,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40407,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32075,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28007,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27580,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21827,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21817,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21656,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18159,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9503,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7711,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7104,
      "timestamp": "2023-03-17T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 421885,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 349683,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 322891,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315587,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190365,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173400,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131091,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125094,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113630,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108024,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70476,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62667,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52438,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40454,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32112,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28009,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27582,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 21991,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21853,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21669,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18162,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9505,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7712,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T00:00:00-04:00",
      "votes": 7104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 423490,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 349955,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 323746,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315701,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190424,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173468,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131306,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125292,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113676,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108041,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70558,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62675,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52449,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40456,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32161,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28011,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T01:00:00-04:00",
      "votes": 27582
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22042,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21861,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21675,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18167,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9507,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7714,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T01:00:00-04:00",
      "votes": 7104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424398,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 350094,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 324211,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315722,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190528,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173489,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131381,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125376,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113715,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108074,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70749,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62690,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52490,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40459,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32168,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28013,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 27582
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 22042
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21874,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21676,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18168,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 9507
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7715,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 7104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424406,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 350207,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 324714,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315790,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190571,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173894,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131520,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125472,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113719,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108089,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70771,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62691,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52495,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 40459
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32172,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 28013
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 27582
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22043,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21875,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21678,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18183,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 9507
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 7715
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 7104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424418,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 350448,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 325225,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315827,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190629,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173915,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131635,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125621,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113729,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108099,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70776,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 62691
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52500,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40462,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32180,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28015,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 27582
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 22043
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21877,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 21678
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18193,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 9507
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7717,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 7104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424419,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 350753,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 325627,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 315867,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190773,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 173929,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131680,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125688,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113756,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108167,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70801,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62692,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52503,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40463,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 32180
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28016,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 27582
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22073,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 21877
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21683,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18227,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9508,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7718,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7105,
      "timestamp": "2023-03-18T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424420,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 351049,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 325904,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 319563,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190871,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 174051,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131722,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125746,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113823,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108204,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 70865,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62698,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52506,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40468,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32182,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28018,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27583,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22114,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T06:00:00-04:00",
      "votes": 21877
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21688,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18263,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9510,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7719,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T06:00:00-04:00",
      "votes": 7105
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424422,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 351617,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 326467,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 319749,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 190988,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 174357,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 131911,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 125830,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 113904,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108212,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 71389,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62700,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52517,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40471,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32193,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 28018
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27584,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22138,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 21892,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21690,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18270,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9521,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 7719
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 7105
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424425,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 352460,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 327944,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 320135,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 191059,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 175100,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132079,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 126119,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114158,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108326,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 71653,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62720,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52558,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40483,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32223,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28027,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27587,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22213,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22002,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21696,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18274,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9526,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7722,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7108,
      "timestamp": "2023-03-18T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 424849,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 354090,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 328914,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 321228,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 191240,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 175311,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132233,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 126402,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114308,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108380,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 71857,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62742,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52639,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40496,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32253,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28037,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27597,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22347,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22053,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21726,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18305,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9529,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7727,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7109,
      "timestamp": "2023-03-18T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 425403,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 354994,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 330048,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 323366,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 191469,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 176302,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132382,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 126559,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114568,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108501,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 72409,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62753,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52673,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40501,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32270,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28039,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27602,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22442,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22083,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21736,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18326,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9535,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7729,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7115,
      "timestamp": "2023-03-18T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 426818,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 356373,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 331648,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 323681,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 191628,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 176975,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132608,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 126832,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114688,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108735,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 72767,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62766,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52739,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40507,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32333,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28062,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27606,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22470,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22121,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21762,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18342,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9538,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7737,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7188,
      "timestamp": "2023-03-18T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 428180,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 357275,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 333379,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 323903,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 191883,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 177362,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 132743,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 127167,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114799,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108779,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 72990,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62818,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52818,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40510,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32401,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28121,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27609,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22482,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22184,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21784,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18351,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9550,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7779,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7201,
      "timestamp": "2023-03-18T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 428854,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 358201,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 334493,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 325025,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 192148,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 178345,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 133000,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 127327,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 114971,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108863,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 73412,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62847,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52867,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40513,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32421,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28124,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27610,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22516,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22269,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21790,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18361,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9558,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7780,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7206,
      "timestamp": "2023-03-18T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 429470,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 359007,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 335368,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 327616,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 192311,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 179182,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 133133,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 127492,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115109,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 108960,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 74460,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62857,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52921,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40522,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32474,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28132,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27613,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22606,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22389,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21796,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18387,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9564,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T14:00:00-04:00",
      "votes": 7780
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7230,
      "timestamp": "2023-03-18T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 429926,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 359974,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 337496,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 327793,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 192603,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 179927,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 133339,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 127715,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115244,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109083,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 74974,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62863,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 52969,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40523,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32573,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28137,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27626,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22613,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22436,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21798,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18428,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9570,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7783,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7234,
      "timestamp": "2023-03-18T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 430911,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 360962,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 338850,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 328008,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 192887,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 180631,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 133639,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 127937,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115503,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109152,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 75261,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62924,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53024,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40526,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32609,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28140,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27627,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22633,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22479,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21804,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18465,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9577,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T16:00:00-04:00",
      "votes": 7783
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7244,
      "timestamp": "2023-03-18T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 431893,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 362105,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 340117,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 328179,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 193300,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 181552,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 133944,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 128190,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115645,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109177,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 75432,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 62948,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53068,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40528,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32687,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28153,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27632,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22735,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22542,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21836,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18528,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9578,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7789,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7246,
      "timestamp": "2023-03-18T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 432497,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 363118,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 341403,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 331086,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 193539,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 182465,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 134230,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 128362,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115764,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109261,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 75850,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63015,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53166,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40542,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32700,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28159,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T18:00:00-04:00",
      "votes": 27632
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22791,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22620,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21840,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18544,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9581,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T18:00:00-04:00",
      "votes": 7789
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7277,
      "timestamp": "2023-03-18T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 433060,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 363903,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 342564,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 331502,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 193858,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 183278,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 134475,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 128600,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 115988,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109351,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 76079,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63021,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53193,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40545,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32831,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28213,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T19:00:00-04:00",
      "votes": 27632
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22805,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22676,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21860,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18564,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9582,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7841,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7316,
      "timestamp": "2023-03-18T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 435680,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 365079,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 344529,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 332494,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 194172,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 184212,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 134690,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 128958,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 116151,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109500,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 76327,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63030,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53240,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40565,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 32978,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28225,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27634,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22836,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22749,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21876,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18590,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9589,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7850,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7388,
      "timestamp": "2023-03-18T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 436001,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 366380,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 346002,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 332903,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 194607,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 185407,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 134912,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 129397,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 116309,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109622,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 76759,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63033,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53292,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40569,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33038,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28241,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27657,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 22919,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22819,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21882,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18603,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9593,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7854,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7401,
      "timestamp": "2023-03-18T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 437218,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 367843,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 347512,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 336533,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 194882,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 187034,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135103,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 129748,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 116453,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 109682,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77328,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63043,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53362,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40583,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33110,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28243,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27687,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23025,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22912,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21888,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18636,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9599,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7855,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7403,
      "timestamp": "2023-03-18T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 437859,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 369220,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 349377,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 336804,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195112,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 189109,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135318,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 130012,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 116934,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110015,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77440,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63324,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53433,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40634,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33118,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28246,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27688,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23124,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22968,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21892,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18656,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9602,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7858,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7426,
      "timestamp": "2023-03-18T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 438951,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 370055,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 350811,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 336990,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195243,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 189891,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135588,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 130456,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 116996,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110050,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77626,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63411,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53442,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40679,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33149,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28248,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T00:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23142,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22984,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21897,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18689,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9603,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7860,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7430,
      "timestamp": "2023-03-19T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 439830,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 370419,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 351653,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 337161,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195274,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 190482,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135679,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 130902,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117011,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110073,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77714,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63415,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53444,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40700,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33164,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28304,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 23142
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22985,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 21897
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18736,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9604,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7915,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 7430
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 440810,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 370700,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 352028,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 337212,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195339,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191079,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135877,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 130961,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117039,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110080,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77755,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63416,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 53444
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 40700
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33172,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28305,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23145,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 22985
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21898,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18740,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 9604
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7917,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7431,
      "timestamp": "2023-03-19T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 440813,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 370848,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 352675,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 340705,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195407,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191561,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 135931,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131196,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117091,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110089,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77960,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63423,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 53444
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40705,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33203,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28306,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23148,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 22985
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21900,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 18740
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 9604
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 7917
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7432,
      "timestamp": "2023-03-19T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 440813
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 371062,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 352706,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 341178,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195412,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191566,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136021,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131314,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117097,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 110089
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 77962,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63425,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53481,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40706,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33208,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 28306
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 23148
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 22985
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21901,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18742,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 9604
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 7917
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7433,
      "timestamp": "2023-03-19T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 440813
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 371882,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 352764,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 341280,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195415,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191616,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136093,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131389,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117101,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 110089
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 78001,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63426,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53483,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40708,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33211,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 28306
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 23148
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 22985
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 21901
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18761,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9605,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7918,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 7433
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 440813
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 372855,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 353243,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 341329,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195519,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191638,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136155,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131488,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117111,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110115,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 78004,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63428,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53493,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40709,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 33211
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28311,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 27688
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23150,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 22986,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21905,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18771,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9606,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 7918
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 7433
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 440813
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 373457,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 354360,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 344190,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195663,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 191941,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136369,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131513,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117190,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110150,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 78142,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63433,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53499,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 40709
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33221,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 28311
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27690,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23175,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23011,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21909,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18778,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9611,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 7918
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 7433
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 440818,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 374456,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 355476,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 344649,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195754,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 192823,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136536,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 131827,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117395,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110196,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 78233,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63440,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53536,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40711,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33296,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28312,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27697,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23205,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23106,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21920,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18801,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9615,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7920,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7500,
      "timestamp": "2023-03-19T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 440917,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 375628,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 356232,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 344851,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 195975,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 194189,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136724,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 132279,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117574,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110241,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 78766,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63447,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53544,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40714,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33310,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28316,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T09:00:00-04:00",
      "votes": 27697
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23217,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23181,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21924,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18820,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9619,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7925,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7531,
      "timestamp": "2023-03-19T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 441248,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 376561,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 356990,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 345308,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 196380,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 195370,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 136924,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 132544,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 117786,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110273,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 79234,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63466,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53562,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40718,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33352,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28323,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27699,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23241,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23225,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21932,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18834,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9682,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7926,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7537,
      "timestamp": "2023-03-19T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 443162,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 377560,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 358037,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 347867,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 196909,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 196682,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137169,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 132834,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118021,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110345,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 79861,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63641,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53572,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40726,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33367,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28329,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27702,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23312,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23298,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21957,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18888,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9686,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7927,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7543,
      "timestamp": "2023-03-19T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 444314,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 378687,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 359816,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 349052,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 197971,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 197739,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137288,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 133090,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118250,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110442,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 79922,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63651,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53596,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40755,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33458,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28332,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27705,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23511,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23402,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21967,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18906,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9694,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7929,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T12:00:00-04:00",
      "votes": 7543
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 444373,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 379652,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 361126,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 349252,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 198974,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 198852,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137443,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 133296,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118510,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110477,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 80288,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63653,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53627,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40784,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33548,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28333,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27708,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23747,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23507,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21975,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18929,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9695,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T13:00:00-04:00",
      "votes": 7929
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7575,
      "timestamp": "2023-03-19T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 444909,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 380836,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 362324,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 349586,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 200064,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 199672,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137666,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 133584,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118652,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110601,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 80706,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63660,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53688,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40787,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33656,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28339,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27710,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 23890,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23554,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 21983,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18974,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9696,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7931,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7600,
      "timestamp": "2023-03-19T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 445737,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 382274,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 363812,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 352618,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 200902,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 200896,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 137844,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 133881,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118792,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110630,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 80859,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63672,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53698,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40795,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33682,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28343,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27714,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24021,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23575,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22000,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 18987,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9698,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7932,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7601,
      "timestamp": "2023-03-19T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 447641,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 383370,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 364823,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 353769,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 202080,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 201786,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 138066,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 134114,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 118890,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 110830,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 80897,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63677,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53747,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40805,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33704,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28344,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27716,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24075,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23668,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22015,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19002,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9703,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7935,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7627,
      "timestamp": "2023-03-19T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 449498,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 384739,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 366088,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 353927,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 203312,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 202551,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 138251,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 134420,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 119053,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111095,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 81333,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63708,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53796,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40814,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33725,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28348,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T17:00:00-04:00",
      "votes": 27716
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24096,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23703,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22018,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19026,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9706,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7936,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7692,
      "timestamp": "2023-03-19T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 451201,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 385912,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 367438,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 354756,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 204660,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 203425,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 138579,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 134987,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 119195,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111253,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 81637,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63713,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53848,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40821,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33781,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28365,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27738,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24162,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23737,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22031,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19050,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9709,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T18:00:00-04:00",
      "votes": 7936
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7702,
      "timestamp": "2023-03-19T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 452966,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 387674,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 368420,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 357879,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 205823,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 204029,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 139050,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 135488,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 119308,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111372,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 82009,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63724,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53919,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40836,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33817,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28389,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27742,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24268,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23764,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22042,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19060,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9711,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7937,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7707,
      "timestamp": "2023-03-19T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 454858,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 389109,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 369746,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 358462,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 207781,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 204620,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 139380,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 136064,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 119479,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111543,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 82570,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63773,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 53968,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40842,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 33863,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28391,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27765,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24294,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23807,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22047,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19096,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9722,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7939,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7721,
      "timestamp": "2023-03-19T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 455293,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 390691,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 371911,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 358836,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 208727,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 205293,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 139671,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 136764,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 119786,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111685,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 83219,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63841,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54103,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40850,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34007,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28394,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27774,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24384,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23944,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22062,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19109,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9730,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7941,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7798,
      "timestamp": "2023-03-19T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 458175,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 392129,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 373174,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 361028,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 209496,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206151,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 140042,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 137348,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120008,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111813,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 83659,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63886,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54160,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40854,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34050,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28395,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27778,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24504,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 23996,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22095,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19196,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9734,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T22:00:00-04:00",
      "votes": 7941
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7848,
      "timestamp": "2023-03-19T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 459578,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 392847,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 375447,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 362697,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 210956,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206431,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 140459,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 137711,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120184,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111860,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 83910,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63918,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54174,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40858,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34092,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28397,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27779,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24609,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24013,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22103,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19206,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9742,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7945,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7854,
      "timestamp": "2023-03-19T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 461638,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 393488,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 377250,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 362780,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 212558,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206628,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 140749,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 137948,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120299,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111902,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84031,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 63964,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54191,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34113,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28399,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 27779
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24637,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24015,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22104,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19208,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 9742
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 7945
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 7854
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 463317,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 393952,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 377582,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 362805,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214181,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206721,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 140871,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138122,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120325,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 111924,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84041,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64231,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54253,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34149,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28400,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27780,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24642,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 24015
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 22104
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19247,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9743,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 7946,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 7854
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 464235,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 394155,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 377727,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 362810,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214260,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206795,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141013,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138147,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120341,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112001,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84048,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64243,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54258,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34150,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28505,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 27780
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 24642
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 24015
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22106,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19250,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9745,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8053,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7856,
      "timestamp": "2023-03-20T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 464250,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 394316,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 377816,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 362901,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214298,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206822,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141028,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138169,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120614,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112012,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84054,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 64243
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 54258
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34153,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 28505
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 27780
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24711,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24016,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22109,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19271,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 9745
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 8053
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 7856
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 464250
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 394499,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 377941,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363048,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214415,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206838,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141086,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138389,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120630,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112021,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84102,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64252,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54259,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 34153
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 28505
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27781,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24748,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24023,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 22109
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 19271
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 9745
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 8053
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 7856
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 464251,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 394961,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 378163,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363107,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214521,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 206886,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141113,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138591,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120676,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112033,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84104,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64258,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 54259
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 40858
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34154,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 28505
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 27781
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24775,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24025,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 22109
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19273,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9746,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8054,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 7856
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 464252,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 396009,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 378835,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363193,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 214757,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 207043,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141250,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138645,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120692,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112073,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84365,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64280,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54264,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40870,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34159,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 28505
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 27781
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24813,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24031,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22110,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19274,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9748,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 8054
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 7856
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 464901,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 396681,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 379290,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363304,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 215792,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 207241,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141395,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 138792,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120698,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112130,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84611,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64386,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54304,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40876,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34192,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28514,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27782,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24823,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24066,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22115,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19297,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9752,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8055,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7861,
      "timestamp": "2023-03-20T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 465601,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 398273,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 380407,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363404,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 216654,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 207437,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141592,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 139032,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120776,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112283,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 84916,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64436,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54333,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40893,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34241,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28521,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27785,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 24871,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24181,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22122,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19308,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9774,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T08:00:00-04:00",
      "votes": 8055
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7893,
      "timestamp": "2023-03-20T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 466341,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 401158,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 381211,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 363672,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 217660,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 207808,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 141728,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 139250,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120851,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112422,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 85182,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64443,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54382,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40906,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34307,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28544,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27787,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25006,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24261,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22129,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19347,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9784,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8057,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7939,
      "timestamp": "2023-03-20T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 468712,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 402719,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 382275,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 366846,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 218768,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 208206,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 142031,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 139702,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 120980,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112612,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 85781,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64463,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54401,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40930,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34332,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28554,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27791,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25039,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24288,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22138,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19348,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9789,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8061,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7952,
      "timestamp": "2023-03-20T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 470035,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 404945,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 383483,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 367122,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 219987,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 208622,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 142284,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 140152,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121113,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112725,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 85938,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64468,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54423,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40940,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34366,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28565,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27795,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25046,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24346,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22150,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19357,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9795,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T11:00:00-04:00",
      "votes": 8061
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7953,
      "timestamp": "2023-03-20T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 471222,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 406354,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 384489,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 367602,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 220682,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 208924,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 142517,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 140826,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121192,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112862,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 86020,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64522,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54490,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 40972,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34406,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28574,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27796,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25060,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24381,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22177,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19372,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9800,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8067,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7962,
      "timestamp": "2023-03-20T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 472310,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 407728,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 385849,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 368146,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 221804,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 209256,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 142730,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 141475,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121303,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 112977,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 86376,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64539,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54578,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41017,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34490,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28583,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27807,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25076,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24416,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22186,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19413,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9803,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T13:00:00-04:00",
      "votes": 8067
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7968,
      "timestamp": "2023-03-20T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 472790,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 408728,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 387569,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 369827,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 222618,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 209645,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 142942,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 142047,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121415,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113163,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 86536,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64872,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54603,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41042,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34535,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28588,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27819,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25079,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24450,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22195,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19434,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9816,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T14:00:00-04:00",
      "votes": 8067
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 7970,
      "timestamp": "2023-03-20T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 473196,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 409506,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 389058,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 371264,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 223689,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 209904,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 143203,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 142526,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121506,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113270,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 86869,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64885,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54694,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41067,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34554,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28604,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27824,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25113,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24520,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22209,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19477,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9819,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8069,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8035,
      "timestamp": "2023-03-20T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 473670,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 410677,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 389823,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 371510,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 224444,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 210228,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 143578,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 143410,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121574,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113573,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 87578,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64898,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54734,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41107,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34612,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28610,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27830,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25145,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24568,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22220,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19494,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9821,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8089,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8072,
      "timestamp": "2023-03-20T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 475181,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 412511,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 391428,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 373011,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 225965,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 210499,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 144944,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 143903,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 121900,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113707,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 87762,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64903,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54853,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41150,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34648,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28665,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27831,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25175,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24628,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22232,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19570,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9835,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8100,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8074,
      "timestamp": "2023-03-20T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 475799,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 413854,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 394016,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 374628,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 227890,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 211244,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 145859,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 144218,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122086,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113803,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 88406,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64918,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 54897,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41171,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34716,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28780,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27834,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25207,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24713,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22244,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19587,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9839,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8156,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8117,
      "timestamp": "2023-03-20T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 476986,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 414965,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 394948,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 375844,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 229543,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 212059,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 146636,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 144415,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122219,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 113919,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 88930,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64924,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55069,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41182,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34809,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28788,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27841,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25366,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24782,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22249,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19683,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9845,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8180,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8125,
      "timestamp": "2023-03-20T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 478527,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 416753,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 396685,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 376133,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 230340,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 212606,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 147289,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 144613,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122303,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 114045,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 90024,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64959,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55125,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41196,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 34910,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 28949,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27844,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25406,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24833,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22281,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19713,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9849,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8333,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8144,
      "timestamp": "2023-03-20T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 480784,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 418432,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 398172,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 376392,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 231974,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 213402,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 147757,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145084,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122479,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 114137,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 91536,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 64987,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55212,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41216,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35007,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29118,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27847,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25549,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24854,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22320,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19757,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9853,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8488,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8157,
      "timestamp": "2023-03-20T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 482771,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 420162,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 400247,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 376664,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 233320,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 213987,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 148318,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145262,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122616,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 114486,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 91749,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65188,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55255,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41239,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35101,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29182,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27853,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25703,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24925,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22355,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19809,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-20T22:00:00-04:00",
      "votes": 9853
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8547,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8158,
      "timestamp": "2023-03-20T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 484399,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 421472,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 401537,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 376836,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 234326,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 214380,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 148720,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145540,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122747,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 115632,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92117,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65215,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55307,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41258,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35176,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29185,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27891,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25806,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24941,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22364,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19838,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9856,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8550,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8160,
      "timestamp": "2023-03-20T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 486636,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 422021,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 402250,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 376982,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 235442,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 214704,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149107,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145628,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122830,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 115831,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92314,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65219,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55314,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41265,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35181,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29187,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27892,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25824,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 24992,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22366,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19848,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9857,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T00:00:00-04:00",
      "votes": 8550
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T00:00:00-04:00",
      "votes": 8160
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 487264,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 422282,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 402362,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377018,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 236860,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 214875,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149351,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145774,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 122851,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 115900,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92331,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65220,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55317,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41266,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35270,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29189,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27896,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25825,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25001,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22368,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19863,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 9857
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 8550
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8162,
      "timestamp": "2023-03-21T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 487265,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 422452,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 402422,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377024,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 237632,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 214908,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149585,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 145981,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123004,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 115970,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92341,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 65220
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55335,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41271,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35272,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 29189
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27897,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 25825
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25003,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22369,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19866,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 9857
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8551,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8175,
      "timestamp": "2023-03-21T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 487265
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 422689,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 402688,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377209,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 237989,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215012,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149647,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146184,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123037,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116037,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92342,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65223,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55350,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 41271
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35292,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 29189
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 27897
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25850,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25005,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22370,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19877,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9859,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 8551
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 8175
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 487265
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 423077,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 403062,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377327,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 238057,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215116,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149768,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146238,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123044,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116114,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92590,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65224,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55351,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41272,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35297,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 29189
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27906,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25880,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25009,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22371,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19901,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 9859
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 8551
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 8175
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 487267,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 423428,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 403352,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377374,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 238128,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215159,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149860,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146301,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123061,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116140,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92729,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65225,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55352,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 41272
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35310,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29190,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27908,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25881,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 25009
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22374,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19912,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9860,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 8551
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 8175
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 487486,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 423665,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 404741,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 377525,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 238270,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215257,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 149896,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146332,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123173,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116317,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 92963,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65232,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55366,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41275,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35330,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 29190
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 27908
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25885,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25013,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22378,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19914,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9863,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 8551
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 8175
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 487518,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 424402,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 405276,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 378475,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 238858,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215539,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 150119,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146516,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123261,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116714,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 93760,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65234,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55373,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41280,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35366,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29199,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27914,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25887,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25115,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22383,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19955,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9864,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8552,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8177,
      "timestamp": "2023-03-21T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 488667,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 425107,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 406187,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 379631,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 239671,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 215790,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 150393,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146654,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123303,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 116943,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 94489,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65242,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55385,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41291,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35412,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29207,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27923,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25911,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25159,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22388,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19962,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9872,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8555,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8180,
      "timestamp": "2023-03-21T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 490153,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 426151,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 406929,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 379923,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 240543,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 216212,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 150879,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 146822,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123433,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117055,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 94955,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65253,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55401,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41303,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35629,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29212,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27926,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 25939,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25177,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22393,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 19986,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9900,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8557,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8182,
      "timestamp": "2023-03-21T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 493576,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 427123,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 407813,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 382692,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 241761,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 216683,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 151365,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 147046,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123635,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117253,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 95388,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65266,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55495,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41359,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35828,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29226,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27947,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26022,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25197,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22402,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20015,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9902,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8559,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8188,
      "timestamp": "2023-03-21T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 495160,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 428321,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 408783,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 382812,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 242041,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 216846,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 151702,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 147339,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 123811,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117440,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 96249,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65321,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55565,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41458,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 35979,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29287,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27949,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26129,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25273,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22421,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20054,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9910,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8563,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8193,
      "timestamp": "2023-03-21T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 495496,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 429244,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 410011,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 382938,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 242474,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 217356,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 152053,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 147645,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124003,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117657,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 97149,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65453,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55666,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41488,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36100,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29308,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27953,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26179,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25320,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22426,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20074,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9911,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8564,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8203,
      "timestamp": "2023-03-21T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 496491,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 430613,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 410708,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 383082,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 242980,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 217903,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 152507,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 147790,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124098,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117759,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 97631,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65522,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55737,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41517,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36313,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29345,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27954,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26216,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25361,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22431,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20110,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9917,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8568,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T13:00:00-04:00",
      "votes": 8203
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 498224,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 431695,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 412014,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 385134,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 243770,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 218374,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 152942,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 147964,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124336,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117824,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 98327,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65530,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55779,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41543,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36494,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29357,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T14:00:00-04:00",
      "votes": 27954
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26272,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25386,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22438,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20131,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9921,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8572,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8206,
      "timestamp": "2023-03-21T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 502409,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 432855,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 413329,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 386828,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 244548,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 218794,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 153470,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 148135,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124600,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 117977,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 98697,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65541,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55800,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41565,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36615,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29376,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27955,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26295,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25404,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22442,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20179,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9926,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8577,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8207,
      "timestamp": "2023-03-21T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 506254,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 433699,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 414328,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 386947,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 245825,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 219014,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 153814,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 148389,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124718,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 118564,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 99567,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65856,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55868,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41572,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36784,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29406,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 27956,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26395,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25423,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22445,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20201,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9934,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8580,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8214,
      "timestamp": "2023-03-21T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 506429,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 434804,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 416129,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 387180,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 246324,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 219338,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 154348,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 148680,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 124909,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 119186,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 100888,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65866,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55932,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41587,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 36884,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29416,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28009,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26524,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25482,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22452,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20225,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9938,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8607,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8215,
      "timestamp": "2023-03-21T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 506852,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 435584,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 417408,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 387374,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 246770,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 219752,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 154966,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 148929,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 125105,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 120069,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 101637,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65878,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 55985,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41636,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37018,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29434,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28037,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26542,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25515,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22465,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20274,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9940,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8618,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8222,
      "timestamp": "2023-03-21T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 508322,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 436925,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 418542,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 387637,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 248525,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 220082,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 155397,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 149197,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 125620,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 120892,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 102300,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65888,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56051,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41651,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37143,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29467,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28056,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26575,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25588,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22475,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20333,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9949,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8622,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8224,
      "timestamp": "2023-03-21T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 511451,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 438233,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 419566,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 387864,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 250683,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 220518,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 155831,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 149507,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 125970,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 121413,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 102870,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65901,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56132,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41667,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37297,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29473,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28076,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26608,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25666,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22495,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20368,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9967,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8623,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8226,
      "timestamp": "2023-03-21T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 513132,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 440164,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 421624,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 391493,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 251844,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 221139,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 156275,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 149757,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 126222,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 121827,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 103802,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65924,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56220,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41679,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37463,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29792,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28152,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26727,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25718,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22501,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20397,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9970,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8930,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T21:00:00-04:00",
      "votes": 8226
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 514190,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 441316,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 423132,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392076,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 253500,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 221707,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 156732,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150144,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 126757,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 122408,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 104525,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65940,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56276,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41697,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37593,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29804,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28187,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26779,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25762,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22506,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20413,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9974,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8932,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8227,
      "timestamp": "2023-03-21T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 514604,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 442853,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 424124,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392183,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 254257,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222073,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157071,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150363,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127128,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123388,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 105399,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 65957,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56281,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41702,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37657,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29810,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28239,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26861,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25804,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22514,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20441,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9978,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 8933,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8231,
      "timestamp": "2023-03-21T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517015,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 443190,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 425463,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392197,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 255762,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222295,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157236,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150580,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127308,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123771,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 105837,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66050,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56288,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41706,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37687,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29813,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28248,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 26982,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25849,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22518,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20453,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T00:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T00:00:00-04:00",
      "votes": 8933
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8232,
      "timestamp": "2023-03-22T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517517,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 443363,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 426005,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392224,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 256594,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222343,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157289,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150634,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127353,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123788,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 106093,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 66050
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 56288
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 41706
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37711,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 29888,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 28248
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27070,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25850,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22521,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20455,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9009,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 8232
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517518,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 443739,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 426494,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392258,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 257140,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222494,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157354,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150654,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127404,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123852,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 106682,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66053,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 56288
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41721,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37728,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30121,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28249,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27101,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 25850
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22522,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20485,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9242,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8235,
      "timestamp": "2023-03-22T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517520,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 443827,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 426665,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392268,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 257310,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222660,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157360,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150661,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127476,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123856,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 106795,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 66053
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56293,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41723,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37738,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 30121
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28251,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27103,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 25850
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 22522
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20497,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 9242
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 8235
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517521,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 444202,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 426807,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392355,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 257392,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222709,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157385,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150731,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127586,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123871,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 106825,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66054,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56294,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41724,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37741,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 30121
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28261,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27105,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 25850
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22523,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20498,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 9242
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 8235
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 517521
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 444705,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 427092,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392425,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 257547,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222743,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157445,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 150963,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127688,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 123888,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 107059,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66057,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56297,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 41724
    },
    {
      "label": "Virginia Union University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 37741
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 30121
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28269,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27107,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25852,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22524,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20501,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 9242
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8236,
      "timestamp": "2023-03-22T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517539,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 445182,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 427338,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392474,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 257567,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 222873,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157485,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 151033,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127752,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 124153,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 107358,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66066,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56301,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41726,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37773,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30124,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28273,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27115,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25854,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22527,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20502,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-22T06:00:00-04:00",
      "votes": 9978
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T06:00:00-04:00",
      "votes": 9242
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8237,
      "timestamp": "2023-03-22T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 517603,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 445527,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 428791,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392507,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 258620,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 223015,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157647,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 151132,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 127914,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 124280,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 108149,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66068,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56332,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41728,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37818,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30132,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28301,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27140,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25861,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22530,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20508,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 9981,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9244,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8266,
      "timestamp": "2023-03-22T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 518670,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 446153,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 429682,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 392673,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 259185,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 223209,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 157800,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 151234,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 128116,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 124378,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 108935,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66084,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56365,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41756,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 37900,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30144,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28314,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27144,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25910,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22531,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20524,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10023,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T08:00:00-04:00",
      "votes": 9244
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8282,
      "timestamp": "2023-03-22T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 520146,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 446953,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 430347,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 393652,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 259381,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 223511,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 158145,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 151452,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 128342,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 124626,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 109425,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66093,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56426,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41827,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38004,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30149,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28330,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27196,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25923,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22544,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20542,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10049,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9250,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8311,
      "timestamp": "2023-03-22T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 521198,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 448287,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 431081,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396127,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 259877,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 223699,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 158577,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 151672,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 128502,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 124906,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 109814,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66099,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56475,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41866,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38029,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30212,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28334,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27229,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 25958,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22556,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20549,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10058,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9257,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8350,
      "timestamp": "2023-03-22T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 522386,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 449348,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 432255,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396241,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 261937,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 223918,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 159011,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 152043,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 128601,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 125143,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 110906,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66113,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56521,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41915,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38114,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30284,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28340,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27269,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26017,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22563,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20561,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10066,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T11:00:00-04:00",
      "votes": 9257
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T11:00:00-04:00",
      "votes": 8350
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 523704,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 450631,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 432907,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396427,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 264044,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 224310,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 159461,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 152275,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 128856,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 125568,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 111470,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66125,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56565,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 41950,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38161,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30303,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28341,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27292,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26051,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22603,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20568,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10069,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9265,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8352,
      "timestamp": "2023-03-22T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 525922,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 451704,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 434060,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396560,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 264826,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 224607,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 159985,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 152795,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 129157,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 126193,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 112300,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66134,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56577,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42014,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38220,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30337,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T13:00:00-04:00",
      "votes": 28341
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27299,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26052,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22608,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20597,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10091,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9289,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8354,
      "timestamp": "2023-03-22T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 528210,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 452771,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 435103,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396654,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 265261,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 224890,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 160340,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 153032,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 129490,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 126815,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 112850,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66298,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56626,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42126,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38303,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30466,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28344,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27334,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26059,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22610,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20606,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10092,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9394,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8357,
      "timestamp": "2023-03-22T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 529731,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 454220,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 435891,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 396806,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 265662,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 225279,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 160702,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 153244,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 129778,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 127543,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 114399,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66449,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56702,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42154,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38347,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30695,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28347,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27341,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26090,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22613,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20633,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10098,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9599,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8375,
      "timestamp": "2023-03-22T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 530619,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 455423,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 436682,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 397073,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 266231,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 225638,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 161282,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 153380,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 130196,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 128492,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 115101,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66456,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56730,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42167,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38381,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30763,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T16:00:00-04:00",
      "votes": 28347
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27373,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26175,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22628,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20656,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10125,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9603,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8389,
      "timestamp": "2023-03-22T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 532871,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 456442,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 438529,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 397205,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 267652,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 225958,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 161461,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 153730,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 130646,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 129093,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 115441,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66461,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56748,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42173,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38531,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30861,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28370,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27427,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26252,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22656,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20666,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10130,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9686,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8393,
      "timestamp": "2023-03-22T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 533621,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 457511,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 439864,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 397394,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 268629,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 226686,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 161961,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 153923,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 131296,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 129426,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 116327,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66471,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56822,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42200,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38620,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30879,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28371,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27458,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26314,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22674,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20672,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10133,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9704,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8394,
      "timestamp": "2023-03-22T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 534302,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 458331,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 441817,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 397597,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 270374,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 227349,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 162373,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 154212,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 132282,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 129748,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 117769,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66478,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56854,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42206,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38716,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30881,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28377,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27503,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26333,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22684,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20688,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10139,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9706,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8398,
      "timestamp": "2023-03-22T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 535758,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 459578,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 444109,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 397838,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 272049,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 227848,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 162704,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 154343,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 132907,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 129998,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 120143,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66507,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56864,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42210,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 38882,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 30934,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28414,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27603,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26380,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22685,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20702,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10142,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 9763,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8402,
      "timestamp": "2023-03-22T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 536681,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 461211,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 446827,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398063,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 274248,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 228352,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 163143,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 154499,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 133661,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 130280,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 122072,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66546,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56924,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42226,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39031,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31198,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28454,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27657,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26446,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22686,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20771,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10148,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10019,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8403,
      "timestamp": "2023-03-22T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 538083,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 463147,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 449146,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398256,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 275423,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 228738,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 163466,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 154809,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 134287,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 130553,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 123590,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66647,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 56995,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T22:00:00-04:00",
      "votes": 42226
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39136,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31206,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28468,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27790,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26483,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22692,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20787,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10161,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10050,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8411,
      "timestamp": "2023-03-22T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 539151,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 464688,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 450042,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398449,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 276724,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229062,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 163745,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155145,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 134643,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131427,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 125085,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66730,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57031,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42230,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39297,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31210,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28472,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 27936,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26501,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22696,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20818,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10165,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10054,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8412,
      "timestamp": "2023-03-22T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540171,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 465205,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 451567,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398591,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 277268,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229313,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164056,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155227,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 135350,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131801,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 125359,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66737,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57043,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T00:00:00-04:00",
      "votes": 42230
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39341,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31216,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28474,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28016,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T00:00:00-04:00",
      "votes": 26501
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22705,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20895,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10166,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10056,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T00:00:00-04:00",
      "votes": 8412
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 540171
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 465721,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 452324,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398618,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 277320,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229394,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164200,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155355,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136125,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131829,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 125763,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 66737
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57048,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 42230
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39383,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31219,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 28474
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 28016
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26502,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22706,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20915,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10170,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10057,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 8412
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 540171
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 466193,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 452421,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398647,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 277574,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229425,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164251,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155414,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136300,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131834,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 126210,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 66737
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 57048
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42234,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39420,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 31219
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 28474
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 28016
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 26502
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22707,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20938,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 10170
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 10057
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8414,
      "timestamp": "2023-03-23T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540495,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 466611,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 452563,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398651,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 278203,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229465,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164320,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155479,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136491,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131870,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 126336,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 66737
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57100,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 42234
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39440,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 31219
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 28474
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28017,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26503,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 22707
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 20960,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 10170
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 10057
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8416,
      "timestamp": "2023-03-23T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540621,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 466801,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 452902,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398702,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 278204,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229497,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164503,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155544,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136732,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131877,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 126574,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 66737
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57137,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42248,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39446,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31220,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 28474
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28018,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 26503
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22714,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21000,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 10170
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10058,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 8416
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540631,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 467081,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 453488,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398828,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 279290,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229534,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164527,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155574,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136926,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 131910,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 127327,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66739,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57186,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 42248
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39451,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 31220
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28477,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28069,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26506,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22718,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21023,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10171,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 10058
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 8416
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540776,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 468239,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 454740,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398844,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 281389,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229601,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164562,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155643,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 136965,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 132049,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 127624,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66745,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57187,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T06:00:00-04:00",
      "votes": 42248
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39495,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31221,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28481,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28081,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26555,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22719,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21038,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10172,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10059,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8417,
      "timestamp": "2023-03-23T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 540926,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 469119,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 455900,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398859,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 282177,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229756,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164738,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155757,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 137121,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 132359,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 128355,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66748,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57223,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42250,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39574,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31235,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28483,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28108,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26612,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22723,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21054,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-23T07:00:00-04:00",
      "votes": 10172
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T07:00:00-04:00",
      "votes": 10059
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8418,
      "timestamp": "2023-03-23T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 541736,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 470071,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 457940,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 398949,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 282661,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 229934,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 164906,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 155959,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 137615,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 132583,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 129865,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66756,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57331,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42257,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39630,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T08:00:00-04:00",
      "votes": 31235
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28489,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28153,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26658,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22728,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21068,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10179,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T08:00:00-04:00",
      "votes": 10059
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8422,
      "timestamp": "2023-03-23T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 542791,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 471405,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 458859,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 400167,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 282896,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 230209,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 165316,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 156146,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 138145,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 132980,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 131551,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66791,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57405,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42262,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39678,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31244,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T09:00:00-04:00",
      "votes": 28489
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28168,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26675,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22744,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21073,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10183,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10063,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8426,
      "timestamp": "2023-03-23T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 543787,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 472619,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 459906,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 400232,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 284353,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 230518,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 165619,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 156377,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 138681,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 133429,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 132691,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66811,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57519,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42279,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39720,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31301,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28490,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28302,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26677,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22756,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21080,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10189,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10065,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8427,
      "timestamp": "2023-03-23T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545061,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 474690,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 460856,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 402905,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 284732,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 230863,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 165923,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 156647,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 139230,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 134823,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 133881,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66831,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57623,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42289,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39820,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31324,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28496,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28492,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26810,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22762,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21126,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10200,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10078,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8428,
      "timestamp": "2023-03-23T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545067,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 476134,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 461096,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403030,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 284884,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 231136,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 166372,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 156902,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 139476,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 136390,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 134277,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66850,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57657,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42306,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39911,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31350,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28628,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28509,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26874,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22766,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21168,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10206,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10082,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T12:00:00-04:00",
      "votes": 8428
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545096,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 476926,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 461294,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403181,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285021,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 231319,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 166534,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 157068,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 139658,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 137517,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 134626,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66853,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57715,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42321,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39952,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31389,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28705,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28516,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26942,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22771,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21185,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10211,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10088,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8429,
      "timestamp": "2023-03-23T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545176,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 478217,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 461528,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403312,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285253,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 231486,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 166945,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 157350,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 139900,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 138700,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 134950,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66865,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57749,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42344,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 39968,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31395,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28739,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28524,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 26993,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22785,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21222,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10215,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10091,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8443,
      "timestamp": "2023-03-23T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545296,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 479167,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 461768,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403457,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285373,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 231722,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 167472,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 157561,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 140377,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 140170,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 135253,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66869,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57805,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42365,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40038,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31464,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28805,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28538,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27014,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22788,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21234,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10217,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T15:00:00-04:00",
      "votes": 10091
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8470,
      "timestamp": "2023-03-23T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545328,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 480347,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 461978,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403526,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285464,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 232064,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 167939,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 157834,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 141955,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 140974,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 135433,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66874,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57832,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42374,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40079,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31526,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28850,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28559,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27041,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22813,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21250,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10220,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T16:00:00-04:00",
      "votes": 10091
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8474,
      "timestamp": "2023-03-23T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545364,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 481314,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 462101,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403569,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285598,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 232252,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 168277,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158051,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 143128,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 141525,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 135557,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66879,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57908,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42381,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40163,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31531,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28911,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28567,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27048,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22818,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21263,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10225,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10093,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8479,
      "timestamp": "2023-03-23T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545379,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 482173,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 462340,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403693,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285754,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 232493,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 168641,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158165,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 143741,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 142041,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 135820,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66892,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 57993,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42386,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40233,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31536,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 28980,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28573,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27115,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22826,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21281,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10226,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10096,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8482,
      "timestamp": "2023-03-23T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545424,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 483174,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 462704,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403750,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 285879,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 232841,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 168876,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158235,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 144963,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 142586,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 136332,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66896,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58148,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T19:00:00-04:00",
      "votes": 42386
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40281,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31548,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29043,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28583,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27146,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22835,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21314,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10232,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T19:00:00-04:00",
      "votes": 10096
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8490,
      "timestamp": "2023-03-23T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545485,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 484263,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 462930,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 403936,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286062,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 233091,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 169235,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158400,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 145903,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 143157,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 136690,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66903,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58285,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42395,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40345,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31557,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29102,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28589,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27181,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22838,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21354,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10236,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T20:00:00-04:00",
      "votes": 10096
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T20:00:00-04:00",
      "votes": 8490
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545681,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 485294,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 463316,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404187,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286282,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 233467,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 169515,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158685,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 146999,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 143675,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137053,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66906,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58450,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42417,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40448,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31564,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29199,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28590,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27228,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22841,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21418,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10241,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10098,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8491,
      "timestamp": "2023-03-23T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545790,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 486445,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 463518,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404344,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286405,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 233712,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 169924,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 158804,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 148066,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 144140,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137429,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66909,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58529,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42419,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40522,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31569,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29319,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28593,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27234,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22844,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21460,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10253,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10099,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8511,
      "timestamp": "2023-03-23T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545874,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 487481,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 463722,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404388,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286541,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 233910,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170302,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159094,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149340,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 144474,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137632,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T23:00:00-04:00",
      "votes": 66909
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58630,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42421,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40534,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31579,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29373,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28610,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27254,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T23:00:00-04:00",
      "votes": 22844
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21475,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10255,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10100,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8518,
      "timestamp": "2023-03-23T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 545930,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 487823,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464012,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404451,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286675,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234060,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170491,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159131,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149583,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 144677,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137826,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66911,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58648,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42425,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40569,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 31579
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29392,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 28610
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27260,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22848,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21491,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10256,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10101,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 8518
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 546003,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 488177,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464134,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404468,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286725,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234132,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170624,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159192,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149649,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 144944,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137874,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66912,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58686,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 42425
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40638,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 31579
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29400,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28611,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27266,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 22848
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21527,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10257,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10102,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 8518
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 546027,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 488363,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464164,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404509,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286749,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234162,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170688,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159212,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149851,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 145072,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137880,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66914,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58689,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42430,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40676,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31580,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29435,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 28611
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27267,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 22848
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21566,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 10257
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 10102
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8519,
      "timestamp": "2023-03-24T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 546035,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 488489,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464407,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404514,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286775,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234166,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170737,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159236,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149902,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 145161,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137884,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 66914
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58694,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 42430
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40678,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 31580
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29458,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 28611
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 27267
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22849,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21610,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 10257
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 10102
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 8519
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 546036,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 488635,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464476,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404539,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 286813,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234230,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170822,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159238,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 149946,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 145220,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 137889,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66915,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 58694
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42447,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40709,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31581,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29461,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 28611
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 27267
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22851,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21647,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 10257
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 10102
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 8519
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 546040,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 488825,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 464833,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404549,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 287009,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234247,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170902,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159279,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 150023,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 145317,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 138372,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 66915
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58704,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 42447
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40710,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31621,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29468,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 28611
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 27267
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 22851
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21657,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10258,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 10102
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 8519
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 547644,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 489657,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 465907,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404613,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 287067,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234310,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 170978,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159387,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 150253,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 145491,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 139092,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66919,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58710,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T06:00:00-04:00",
      "votes": 42447
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40726,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31626,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29469,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28615,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27269,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22852,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21660,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-24T06:00:00-04:00",
      "votes": 10258
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10103,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8520,
      "timestamp": "2023-03-24T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 549469,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 490143,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 467476,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404658,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 288178,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234401,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 171142,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159492,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 150664,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 146073,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 139624,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66923,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58746,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42448,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40791,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 31626
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29470,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28616,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27278,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 22852
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21670,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10266,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 10103
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8522,
      "timestamp": "2023-03-24T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 551109,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 491045,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 468242,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 404842,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 288464,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234533,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 171283,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159595,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 151010,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 146832,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 140422,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66931,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58815,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42449,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40838,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31631,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29506,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28623,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27295,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22859,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21675,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10279,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10106,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8552,
      "timestamp": "2023-03-24T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 552876,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 491698,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 469385,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 406349,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 288560,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234674,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 171444,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 159737,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 151171,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 147505,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 141207,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66952,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58864,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42455,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 40972,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31637,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29541,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28626,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27306,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22867,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21686,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10295,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10109,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8553,
      "timestamp": "2023-03-24T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 554808,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 492441,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 470760,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 408096,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 289045,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 234919,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 171668,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 160164,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 151572,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 148028,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 141666,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66957,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58894,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42462,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41061,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31646,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29607,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28633,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27464,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22874,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21699,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10302,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10112,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8554,
      "timestamp": "2023-03-24T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 555215,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 493403,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 471492,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 408253,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 289407,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 235140,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 171921,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 160498,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 152178,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 148397,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 141974,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66966,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 58988,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42477,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41114,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31676,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29630,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28649,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27519,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T11:00:00-04:00",
      "votes": 22874
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21717,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10309,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T11:00:00-04:00",
      "votes": 10112
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8555,
      "timestamp": "2023-03-24T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 557024,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 494439,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 472956,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 408343,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 289971,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 235313,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 172110,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 160788,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 153039,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 148712,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 142284,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 66990,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59026,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42483,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41190,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31684,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29640,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28657,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27546,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22879,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21736,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10321,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10116,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8561,
      "timestamp": "2023-03-24T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 558857,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 495134,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 473959,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 408523,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 290729,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 235502,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 172336,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 161059,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 153955,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 149573,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 142759,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67016,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59082,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42525,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41346,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31692,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29665,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28659,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27614,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22880,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21754,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10325,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10149,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8562,
      "timestamp": "2023-03-24T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 561230,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 496131,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 475427,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 408652,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 291465,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 235735,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 172502,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 161366,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 154817,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 150483,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 143897,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67056,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59170,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42535,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41424,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31781,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29717,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28676,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27702,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22930,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21812,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10327,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10151,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8565,
      "timestamp": "2023-03-24T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 562252,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 496900,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 476895,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 409921,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 292277,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 236072,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 172705,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 161636,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 155878,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 151273,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 144241,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67062,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59263,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42542,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41516,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31863,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29749,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28677,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 27983,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22935,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21945,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10328,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10154,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8568,
      "timestamp": "2023-03-24T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 562733,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 497927,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 478329,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410273,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 293120,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 236290,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 172955,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 161864,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 156891,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 152393,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 144539,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67069,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59296,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42546,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41589,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31864,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29776,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28693,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28173,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22937,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21978,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10333,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10159,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8577,
      "timestamp": "2023-03-24T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 563557,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 498774,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 480252,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410340,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 294911,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 236505,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 173252,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 162017,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 158072,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 153302,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 145115,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67077,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59331,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42562,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 41894,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31865,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29797,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28702,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28269,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22945,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 21993,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10341,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10162,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8579,
      "timestamp": "2023-03-24T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 564627,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 499882,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 482483,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410416,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 296411,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 236706,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 173563,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 162212,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 158797,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 154140,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 145610,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67090,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59365,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42587,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42051,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31869,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29819,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28719,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28380,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22951,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22028,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10344,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10164,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8587,
      "timestamp": "2023-03-24T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 566352,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 501307,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 484703,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410551,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 298317,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 236916,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 173844,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 162585,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 159269,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 155327,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 145970,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67097,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59421,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42590,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42241,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31872,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29850,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28739,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28430,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22956,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22050,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10355,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10166,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8590,
      "timestamp": "2023-03-24T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 567917,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 503632,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 485859,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410652,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 300177,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 237351,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 174151,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 163042,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 160065,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 156483,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 146516,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67101,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59452,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42623,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42334,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31873,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 29974,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28763,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28444,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22958,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22104,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10360,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T20:00:00-04:00",
      "votes": 10166
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T20:00:00-04:00",
      "votes": 8590
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 568594,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 504711,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 487730,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410719,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 301450,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 237656,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 174452,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 163399,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 160691,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 157494,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 147383,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67105,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59489,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42641,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42483,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31901,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30038,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28765,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28487,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22979,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22145,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10364,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10167,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8629,
      "timestamp": "2023-03-24T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 570836,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 506162,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 489339,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410769,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 302247,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 237941,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 174691,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 163726,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 161724,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 158549,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 148014,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67124,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59507,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42662,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42643,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31903,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30104,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28770,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28536,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22982,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22164,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10366,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10169,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8633,
      "timestamp": "2023-03-24T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 572084,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 507709,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 491286,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410845,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 303145,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238235,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 175019,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 164207,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 162962,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 159996,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 148576,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67131,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59519,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42793,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42675,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31922,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30171,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28823,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28558,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22984,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22209,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10369,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T23:00:00-04:00",
      "votes": 10169
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8637,
      "timestamp": "2023-03-24T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 573163,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 508545,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 492190,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410894,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 303971,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238416,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 175545,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 164656,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163503,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 160786,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149110,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T00:00:00-04:00",
      "votes": 67131
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59540,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42875,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42749,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31937,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30180,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28840,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28565,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22987,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22270,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10370,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10171,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8639,
      "timestamp": "2023-03-25T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 574649,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 509447,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 492802,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410916,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 304714,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238486,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 175813,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 164776,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163597,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 161033,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149389,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67132,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59548,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42958,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42781,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 31937
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 30180
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 28840
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28586,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22989,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22271,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10372,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10172,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8650,
      "timestamp": "2023-03-25T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 575009,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 509845,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 493244,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410964,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 305125,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238516,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176076,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 164910,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163624,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 161596,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149423,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67135,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59559,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42962,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42816,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 31937
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30184,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 28840
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28592,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 22989
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22307,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 10372
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 10172
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 8650
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 575011,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 510055,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 493614,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410968,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 305177,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238535,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176124,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165093,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163709,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 161666,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149619,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67136,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 59559
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 42994,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42817,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31939,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30189,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28843,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28594,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 22989
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22363,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 10372
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 10172
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 8650
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 575012,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 510264,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 494901,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 410968
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 305400,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238536,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176229,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165213,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163742,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 161739,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149648,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 67136
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59575,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43001,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 42817
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31941,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30200,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 28843
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28646,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 22989
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22376,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 10372
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 10172
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8651,
      "timestamp": "2023-03-25T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 575579,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 510776,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 495259,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 410985,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 305534,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238559,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176283,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165254,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 163754,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 162071,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 149811,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67140,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 59575
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43024,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42819,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31942,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30225,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 28843
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 28646
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 22989
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 22376
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10375,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 10172
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 8651
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 575679,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 511167,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 495800,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411040,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 305866,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238622,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176304,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165380,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 164125,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 162651,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 150040,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67142,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59579,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43057,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T06:00:00-04:00",
      "votes": 42819
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31943,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30226,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28848,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28647,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22990,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22397,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10376,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10173,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T06:00:00-04:00",
      "votes": 8651
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 576517,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 512410,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 497013,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411133,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 306360,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238724,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176383,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165551,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 164338,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 163629,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 150322,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67150,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59586,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43105,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42840,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31945,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30241,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T07:00:00-04:00",
      "votes": 28848
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28672,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T07:00:00-04:00",
      "votes": 22990
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22410,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10377,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10177,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T07:00:00-04:00",
      "votes": 8651
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 577327,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 513220,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 498730,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411292,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 307324,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 238925,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176442,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 165772,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 165527,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 164861,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 150721,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67156,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59589,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43128,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42866,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31951,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30258,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28849,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28734,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22993,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22494,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10383,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10189,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8676,
      "timestamp": "2023-03-25T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 579432,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 515032,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 500740,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411454,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 307641,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 239125,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176578,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 167080,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 166142,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 165809,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 150863,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67159,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59676,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43201,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42870,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31952,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30295,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28850,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28758,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22996,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22500,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10385,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T09:00:00-04:00",
      "votes": 10189
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8677,
      "timestamp": "2023-03-25T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 580393,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 517238,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 501845,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411696,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 308824,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 239297,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 176907,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 168048,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 166658,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 166451,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 151430,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67174,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59722,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43370,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42899,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31954,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30336,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 28911,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28858,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 22999,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22514,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10386,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10193,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8680,
      "timestamp": "2023-03-25T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 580879,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 518964,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 503727,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411790,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 310300,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 239444,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 177197,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 169771,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 167388,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 167048,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 152461,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67177,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59730,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43440,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42940,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31959,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30372,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29017,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28859,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23002,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22541,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10388,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10198,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8685,
      "timestamp": "2023-03-25T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 581353,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 520598,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 504736,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 411868,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 311138,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 239539,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 177501,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 170728,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 167855,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 167393,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 152877,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67180,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59736,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43525,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 42975,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31964,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30398,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29124,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28864,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23008,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22560,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10389,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10202,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8687,
      "timestamp": "2023-03-25T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 583683,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 522422,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 505849,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 412017,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 312104,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 239782,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 177832,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 171940,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 168507,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 167775,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 153100,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67182,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59763,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43561,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43020,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31973,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30467,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29167,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28868,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T13:00:00-04:00",
      "votes": 23008
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22571,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T13:00:00-04:00",
      "votes": 10389
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10208,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8699,
      "timestamp": "2023-03-25T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 585213,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 523744,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 508018,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 412149,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 314243,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 240090,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 178391,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 173046,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 169443,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 168391,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 153320,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67186,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59838,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43653,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43025,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 31999,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30551,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29202,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28873,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23012,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22591,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10394,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T14:00:00-04:00",
      "votes": 10208
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8723,
      "timestamp": "2023-03-25T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 585968,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 524948,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 508944,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 414976,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 315034,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 240326,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 178954,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 175132,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 170078,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 168680,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 153910,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67195,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59891,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43728,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43028,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32002,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30671,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29257,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28874,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23025,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22616,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10396,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T15:00:00-04:00",
      "votes": 10208
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8768,
      "timestamp": "2023-03-25T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 587313,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 526131,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 510078,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 415725,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 315250,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 240561,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 179501,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 175850,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 170661,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 168958,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 154554,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67199,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 59953,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43758,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43034,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32003,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30750,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29285,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28880,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23028,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22664,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10399,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10209,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8813,
      "timestamp": "2023-03-25T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 589020,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 527696,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 511835,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 415789,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 316021,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 240773,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 180545,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 177369,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 171361,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 169328,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 155421,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67204,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60037,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 43865,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43075,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32004,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30790,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29312,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28905,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23050,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22704,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10403,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10210,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8881,
      "timestamp": "2023-03-25T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 590235,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 528694,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 513791,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 415929,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 317936,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 241079,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 181103,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 178679,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 171917,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 169820,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 155667,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67222,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60084,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44037,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43087,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32007,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 30874,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29351,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28906,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23054,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22781,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T18:00:00-04:00",
      "votes": 10403
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10224,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8929,
      "timestamp": "2023-03-25T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 591966,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 529838,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 515722,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 416069,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 318965,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 241362,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 181594,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 180426,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 172482,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 170799,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 156239,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67291,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60142,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44176,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43090,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32009,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31021,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29419,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28907,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23114,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22815,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10406,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10235,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8937,
      "timestamp": "2023-03-25T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 593200,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 532558,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 518292,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 416196,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 320236,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 241724,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 182468,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 182345,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 173006,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 171754,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 157005,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67297,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60192,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44276,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43099,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32018,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31111,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29505,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28908,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23131,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22854,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10411,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10237,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8956,
      "timestamp": "2023-03-25T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 594572,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 534752,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 521074,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418158,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 323155,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 242208,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 185262,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 183072,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 173852,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 172311,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 157412,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67306,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60265,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44310,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43115,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32037,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31206,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29525,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T21:00:00-04:00",
      "votes": 28908
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23133,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22882,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-25T21:00:00-04:00",
      "votes": 10411
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10239,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 8986,
      "timestamp": "2023-03-25T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 598439,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 537020,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 523163,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418366,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 324115,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 242709,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 187449,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 183883,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 174522,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 173198,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158196,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T22:00:00-04:00",
      "votes": 67306
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60291,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44447,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43120,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32043,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31323,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29539,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28910,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23144,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 22948,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10417,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10240,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9003,
      "timestamp": "2023-03-25T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 599713,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 538298,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 524707,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418471,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 325078,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243084,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 189321,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 184667,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 175245,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 173686,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158513,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67311,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60305,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44523,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43135,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32045,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31412,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29572,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28911,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23148,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23011,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10420,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10241,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9012,
      "timestamp": "2023-03-25T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 600621,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 539380,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 526454,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418509,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 325975,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243216,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 190509,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185184,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 175538,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174064,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158586,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67314,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60314,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44558,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43160,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32050,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31464,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29577,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28914,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23152,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23053,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10421,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10244,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9018,
      "timestamp": "2023-03-26T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 600681,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 539947,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 527765,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418525,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 326613,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243267,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 191462,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185402,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 175750,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174412,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158631,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67320,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 60314
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44563,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43212,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 32050
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31471,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29586,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28916,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23153,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23067,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 10421
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10245,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9022,
      "timestamp": "2023-03-26T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 600969,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 540148,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 528406,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418546,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 326889,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243311,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 192084,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185489,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 175808,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174479,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158660,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67322,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60315,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44571,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43255,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32051,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 31471
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29587,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 28916
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23154,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23078,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 10421
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10246,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9031,
      "timestamp": "2023-03-26T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 600984,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 540618,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 529468,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418550,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 327060,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243367,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 192715,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185527,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 175969,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174542,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158771,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 67322
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60318,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44574,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43275,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32052,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31473,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29589,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28918,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23155,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23085,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 10421
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10248,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9065,
      "timestamp": "2023-03-26T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 600984
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 541410,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 529798,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418596,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 327886,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243408,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 192858,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185647,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 176081,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174574,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 158873,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 67322
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60320,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44593,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 43275
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32053,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31493,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29590,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 28918
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23156,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 23085
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 10421
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9103,
      "timestamp": "2023-03-26T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 601013,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 541697,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 530040,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418641,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 327960,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243478,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 192911,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185796,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 176214,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174681,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 159028,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 67322
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60322,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44607,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 43275
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 32053
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 31493
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29592,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 28918
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 23156
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 23085
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 10421
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 9103
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 601018,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 542002,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 530612,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418722,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 328059,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243530,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 193369,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 185908,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 176446,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 174973,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 159290,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67323,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 60322
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44634,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43277,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 32053
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31501,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29593,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28920,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 23156
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23086,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10422,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9104,
      "timestamp": "2023-03-26T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 601040,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 542848,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 531006,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418748,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 328114,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243588,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 193723,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 186050,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 176878,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 175190,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 159578,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67326,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60336,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44638,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43278,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32055,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 31501
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29609,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28921,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23158,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 23086
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10423,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 9104
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 601055,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 544463,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 532983,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418799,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 328261,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 243713,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 193985,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 186482,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 177318,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 175508,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 159760,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67328,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60345,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44663,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T08:00:00-04:00",
      "votes": 43278
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32056,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31506,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29618,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28922,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23160,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23090,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10424,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T08:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9107,
      "timestamp": "2023-03-26T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 601538,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 545790,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 534265,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418824,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 329264,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 244016,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 194555,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 187085,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 177643,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 175657,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 159973,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67336,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60355,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44802,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43280,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32057,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31632,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29629,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28924,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23169,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23130,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10425,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T09:00:00-04:00",
      "votes": 10248
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9114,
      "timestamp": "2023-03-26T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 603728,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 548838,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 535582,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 418883,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 330431,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 244190,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 195889,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 187709,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 178014,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 175969,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 160034,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67645,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60361,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44891,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43290,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32060,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31681,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29631,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28933,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23179,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23141,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T10:00:00-04:00",
      "votes": 10425
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10250,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9115,
      "timestamp": "2023-03-26T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 604664,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 551225,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 537433,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419008,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 331038,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 244410,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 197223,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 188436,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 178535,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 176120,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 160173,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67650,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60373,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 44965,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43320,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32064,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31729,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T11:00:00-04:00",
      "votes": 29631
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28943,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23190,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23183,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10427,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10254,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9137,
      "timestamp": "2023-03-26T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 606067,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 552942,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 539020,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419085,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 331799,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 244688,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 198559,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 189170,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 178950,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 176335,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 160352,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67653,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60377,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45122,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43341,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32065,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31792,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29640,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28945,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23221,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23194,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10429,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T12:00:00-04:00",
      "votes": 10254
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9152,
      "timestamp": "2023-03-26T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 607740,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 554574,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 540422,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419119,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 333035,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 245175,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 200145,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 189796,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 179448,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 176531,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 160800,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67661,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60421,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45287,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43360,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32066,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31866,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29652,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28949,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23318,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23197,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10432,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T13:00:00-04:00",
      "votes": 10254
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9153,
      "timestamp": "2023-03-26T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 608708,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 556614,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 542253,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419160,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 334388,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 245684,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 201334,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 190432,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 179716,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 176784,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 161288,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67671,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60427,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45381,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43365,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32071,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31899,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29764,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T14:00:00-04:00",
      "votes": 28949
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23333,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23199,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T14:00:00-04:00",
      "votes": 10432
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10260,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9154,
      "timestamp": "2023-03-26T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 609795,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 558803,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 544939,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419237,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 335019,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 246154,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 202204,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 191134,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 180034,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 177025,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 161806,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67675,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60493,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45430,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43374,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32083,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31937,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29851,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28952,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23355,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23258,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10435,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10261,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9163,
      "timestamp": "2023-03-26T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 612138,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 561233,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 546880,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419394,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 335880,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 246612,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 203202,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 192161,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 180289,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 177420,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 161969,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67688,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60569,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45574,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43381,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32084,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 31990,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29912,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28955,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23383,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23292,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T16:00:00-04:00",
      "votes": 10435
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10262,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9170,
      "timestamp": "2023-03-26T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 614472,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 563041,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 548378,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419476,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 337026,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 247214,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 203960,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 192909,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 180696,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 177874,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 162238,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67695,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60633,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45794,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43382,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32146,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32087,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29927,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28957,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23402,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23296,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10437,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10264,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9173,
      "timestamp": "2023-03-26T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 615423,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 564539,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 550370,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419747,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 339320,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 247794,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 204817,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 193482,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 181233,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 178200,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 162574,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 67946,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60674,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45904,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43388,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32225,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32088,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29937,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28960,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23428,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23307,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10441,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10267,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9174,
      "timestamp": "2023-03-26T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 616715,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 566277,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 551705,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 419845,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 341125,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 248193,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 205951,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 194522,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 181626,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 178584,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 163496,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68412,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60716,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 45975,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43452,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32255,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32090,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 29994,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28962,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23448,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23315,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10447,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T19:00:00-04:00",
      "votes": 10267
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9178,
      "timestamp": "2023-03-26T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 619499,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 569772,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 556230,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 420079,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 342915,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 248704,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 206889,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 195486,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 182719,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 178925,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 164008,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68417,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60762,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 46129,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43569,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32275,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32094,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 30079,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28963,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23488,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23320,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10448,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10270,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9182,
      "timestamp": "2023-03-26T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 622356,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 572882,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 559026,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 420252,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 344925,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 249336,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 207712,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 196582,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 183398,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 179447,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 165409,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68425,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60802,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 46301,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43619,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32316,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32098,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 30180,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28969,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23520,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23323,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10449,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10272,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9185,
      "timestamp": "2023-03-26T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 622475,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 574896,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 559723,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 420429,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 345323,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 249780,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 208317,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 197739,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 183915,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 179947,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 165558,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68428,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60805,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 46386,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43628,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32377,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32103,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 30232,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28971,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23606,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23327,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10450,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10275,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9228,
      "timestamp": "2023-03-26T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 622575,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 577038,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 560451,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 420705,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 345715,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 250241,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 209166,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 198508,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 184670,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 180526,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 165697,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68429,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60842,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 46496,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "votes": 43636,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32457,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "votes": 32106,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Fort Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "votes": 30253,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Coppin State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "votes": 28981,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23722,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23332,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "votes": 10451,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10280,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "votes": 9328,
      "timestamp": "2023-03-26T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Coahoma Community College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/44f2ef77-bfe1-4295-8692-2954ff9f36d1.png",
      "votes": 622597,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "South Carolina State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/cdfe6d50-2ef5-41a6-9881-f634ea67ece8.png",
      "votes": 577369,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Tuskegee University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/34763371-489b-4194-9bfb-1319f3e306e9.png",
      "votes": 560578,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Bethune-Cookman University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d318aeb5-93f2-480d-b82b-5d4cc387ae95.png",
      "votes": 420751,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Kentucky State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5c171c6-e69f-4e8a-96fd-770032054528.png",
      "votes": 345726,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Benedict College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fc8514ff-3743-40d9-aa46-8f2e42dacda8.png",
      "votes": 250336,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Savannah State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/aa7cafb9-208d-4221-acc9-a99a3d547b64.png",
      "votes": 209384,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "University of Arkansas at Pine Bluff",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6fb94afd-87e5-452b-886e-a4fe0d248a9c.png",
      "votes": 198740,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "University of Maryland Eastern Shore",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e732eab7-7f28-467e-af80-75947fdd424f.png",
      "votes": 184834,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Mississippi Valley State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b0a98c9-1a7a-4504-bc49-d8f4101b57f3.png",
      "votes": 180712,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "West Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/468c91d3-19b1-47f3-aed5-8ac3d4b67200.png",
      "votes": 165707,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Spelman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e9514dbd-31ab-4548-a42d-7bf8bdcc2840.png",
      "votes": 68430,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Elizabeth City State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/1264ebe2-c6f7-42ac-a95e-13b54522d443.png",
      "votes": 60846,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Virginia Union University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69612c11-21a1-468a-b79c-021b1fb28e9d.png",
      "votes": 46511,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Missouri",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/3b686eae-6903-4dc8-a80c-22e9ce1a0a91.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 43636
    },
    {
      "label": "Claflin University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/69cf1f90-a5f7-4ff1-8a63-80d7a4346bde.png",
      "votes": 32472,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Southern University at New Orleans",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/ccfe98ce-034a-49f8-b202-178701531505.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 32106
    },
    {
      "label": "Fort Valley State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67162447-3658-4b3f-baf1-9a774145d77f.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 30253
    },
    {
      "label": "Coppin State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/739bd40e-c90a-465f-b27f-9925e03d6ca3.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 28981
    },
    {
      "label": "Virginia State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/700ca4ee-4568-4c57-982a-5e144e00301e.png",
      "votes": 23725,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Xavier University of Louisiana",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/9244afb1-51b3-4f80-98dd-73a75b7fedf1.png",
      "votes": 23333,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Lincoln University of Pennsylvania",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7279a93d-b389-4849-b6e0-fab7f0527d96.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 10451
    },
    {
      "label": "Southern University at Shreveport (Bossier City)",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0181805d-779a-49de-81bb-41a1feec50e9.png",
      "votes": 10281,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Miles College ",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/74102553-dc68-4446-8181-d3be83c79c61.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 9328
    }
  ]
]
